{
  "recruiting": "Recrutamento",
  "courses": "Cursos",
  "courses-page": {
    "title": "Cursos",
    "create": "Criar curso",
    "edit": "Editar curso",
    "empty": "Nenhum curso ainda",
    "fields": {
      "title": "Título",
      "description": "Descrição",
      "documents-count": "Documentos"
    },
    "headers": {
      "title": "Título",
      "description": "Descrição",
      "documents": "Documentos",
      "actions": "Ações"
    },
    "dialog": {
      "title-label": "Título",
      "description-label": "Descrição",
      "documents-label": "Documentos",
      "documents-placeholder": "Selecione documentos da base de conhecimento",
      "save": "Salvar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Curso criado",
      "updated": "Curso atualizado",
      "deleted": "Curso excluído",
      "error": "Algo deu errado"
    },
    "confirm-delete": "Excluir este curso? Essa ação não pode ser desfeita."
  },
  "ai-study-chat": "Chat de estudo com IA",
  "ai-study-chat-page": {
    "title": "Chat de estudo com IA",
    "new-conversation": "Nova conversa",
    "empty-sidebar": "Nenhuma conversa ainda",
    "empty-thread": "Selecione um curso ou cenário para começar a aprender",
    "untitled": "Novo chat",
    "input-placeholder": "Digite sua pergunta…",
    "send": "Enviar",
    "typing": "O assistente está digitando…",
    "sources": "Fontes ({count})",
    "sources-label": "Fontes",
    "score": "relevância",
    "retry": "Tentar novamente",
    "copy": "Copiar",
    "copied": "Copiado",
    "failed": "Falha ao enviar",
    "search-placeholder": "Pesquisar conversas",
    "search-empty": "Nenhum resultado encontrado",
    "empty": {
      "heading": "Pronto para ajudar você a aprender",
      "subtitle": "Pergunte qualquer coisa sobre os materiais do curso — vou encontrar a resposta na base de conhecimento e mostrar as fontes."
    },
    "groups": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "earlier": "Anteriores"
    },
    "composer": {
      "context": "Contexto:",
      "hint": "As respostas são geradas por IA com base nos seus materiais · Enter para enviar, Shift+Enter para nova linha"
    },
    "suggestions-fallback": [
      {
        "title": "Resumir os materiais",
        "subtitle": "Pontos principais"
      },
      {
        "title": "Criar um plano de estudos",
        "subtitle": "Por onde começar"
      },
      {
        "title": "Me fazer um quiz",
        "subtitle": "Revisão rápida"
      },
      {
        "title": "Explicar de forma simples",
        "subtitle": "Sem jargões"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Analisar esta sessão", "subtitle": "Principais aprendizados" },
      { "title": "O que eu fiz bem?", "subtitle": "Meus pontos fortes" },
      { "title": "Onde errei e por quê?", "subtitle": "Pontos de crescimento" },
      { "title": "O que melhorar na próxima sessão?", "subtitle": "Passos concretos" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Como estão evoluindo meus resultados?", "subtitle": "Entre sessões" },
      { "title": "Minhas habilidades fortes e fracas", "subtitle": "Com base nos resultados das sessões" },
      { "title": "No que devo me concentrar?", "subtitle": "Prioridade de treino" },
      { "title": "Comparar minha primeira e última sessão", "subtitle": "O que melhorou" }
    ],
    "quota": {
      "remaining": "{count} mensagens restantes",
      "exhausted": "Você esgotou suas mensagens de chat com IA.",
      "unavailable": "O chat com IA não está disponível no seu plano."
    },
    "new-dialog": {
      "title": "Nova conversa",
      "subtitle": "Escolha a fonte da qual a IA vai responder",
      "source-type": "Fonte",
      "source-course": "Curso",
      "source-scenario": "Cenário",
      "source-competency": "Competência",
      "pick-course": "Selecione um curso",
      "pick-scenario": "Selecione um cenário",
      "pick-competency": "Selecione uma competência",
      "pick-target": "Todas as sessões ou uma sessão específica",
      "all-games": "Todas as sessões — meu progresso",
      "all-games-sub": "Tendências de resultados para esta competência",
      "back": "Voltar",
      "no-games": "Nenhuma sessão concluída",
      "empty-competencies": "Ainda não há sessões concluídas",
      "empty-competencies-hint": "Conclua uma sessão de um cenário com competência — a análise da IA aparecerá aqui",
      "empty-courses": "Ainda não há cursos disponíveis",
      "empty-scenarios": "Ainda não há cenários disponíveis",
      "tag-game": "Sessão",
      "search": "Pesquisar…",
      "search-empty": "Nenhum resultado encontrado",
      "start": "Iniciar",
      "cancel": "Cancelar"
    },
    "stage": {
      "searching": "Pesquisando nos seus materiais…",
      "reading": "Lendo as fontes…",
      "writing": "Escrevendo a resposta…",
      "writing_sources": "Analisando {count} trechos…",
      "summarizing_short": "Organizando o contexto anterior",
      "searching_short": "Pesquisando seus materiais",
      "reading_short": "Lendo as fontes",
      "writing_short": "Escrevendo a resposta",
      "writing_sources_short": "Analisando {count} trechos"
    },
    "errors": {
      "send": "Não foi possível enviar sua mensagem. Por favor, tente novamente.",
      "quota": "Cota de mensagens atingida.",
      "rate_limit": "Muitas solicitações. Aguarde um minuto e tente novamente.",
      "provider_unsupported": "O chat da base de conhecimento não está disponível com o provedor de IA atual da sua organização.",
      "generic": "Algo deu errado."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Página não encontrada ⚠️",
  "404_description": "Não conseguimos encontrar a página que você está procurando.",
  "404_home": "Voltar para o início",
  "401_title": "Você não está autorizado! 🔐",
  "401_description": "Você não tem permissão para acessar esta página. Volte para a página inicial.",
  "401_home": "Voltar para o início",
  "changes_saved": "Alterações salvas",
  "coming_soon": "Em breve",
  " ": " ",
  "select_date_and_time": "Selecione data e hora",
  "select_date": "Selecione a data",
  "chat": "Chat",
  "menu": "Menu",
  "games": "Sessões",
  "tours": "Tours",
  "library": "Biblioteca",
  "library-video": "Vídeo",
  "library-scorm": "Cursos",
  "library-documents": "Documentos",
  "scenarios": "Cenários",
  "competencies": "Competências",
  "competencies-list": "Lista",
  "skills": "Habilidades",
  "home": "Início",
  "home_player": "Participante",
  "player": "Participante",
  "home_expert": "Especialista",
  "reports-analytics-tours": "Tours",
  "reports": "Relatórios",
  "ranking": "Ranking",
  "analytics": "Análises",
  "support": "Suporte",
  "users": "Usuários",
  "participants": "Participantes",
  "departments": "Departamentos",
  "positions": "Cargos",
  "user-custom-fields": "Campos personalizados",
  "administration": "Administração",
  "ai-assistants": "Assistentes de IA",
  "ai-profiles": "Perfis de IA",
  "ai-connectors": "Conectores de IA",
  "Audit logs": "Registros de auditoria",
  "organizations": "Organizações",
  "loading": "Carregando...",
  "retry": "Tentar novamente",
  "previous": "Anterior",
  "next": "Próximo",
  "save": "Salvar",
  "copy": "Copiar",
  "copy_failed": "Não foi possível copiar automaticamente. Selecione o texto no campo e copie manualmente (Ctrl+C ou ⌘C).",
  "confirm": "Confirmar",
  "suggest": "Sugerir",
  "generate": "Gerar",
  "cancel": "Cancelar",
  "close": "Fechar",
  "search": "Pesquisar...",
  "accept": "Aceitar",
  "propose": "Propor",
  "decline": "Recusar",
  "send_request": "Enviar solicitação",
  "assign": "Atribuir",
  "actions": " ",
  "evaluators": {
    "ai": "IA",
    "expert": "Especialista",
    "player": "Participante",
    "manager": "Gestor",
    "head": "Responsável"
  },
  "statistics": {
    "date_from": "De",
    "date_to": "Até",
    "competence": "Competência",
    "evaluator": "Avaliador",
    "last_games_effectiveness": {
      "effectiveness": "Efetividade",
      "title": "Progresso de efetividade"
    },
    "skill_trend": {
      "average_score": "Pontuação média",
      "game": "Sessão",
      "score": "Pontuação",
      "title": "Pontuação média por competências"
    },
    "player_competence_radar": {
      "title": "Estatísticas de habilidades",
      "top": "Top 10",
      "players_in_company": "Participantes na empresa",
      "by_games": "Análises por sessões",
      "subtitle": "Comparação com a média da empresa",
      "filter": "Filtro",
      "you": "Você",
      "company": "Empresa",
      "average_score": "pontuação média",
      "skills_counted": "com base em {counted} de {total} habilidades"
    }
  },
  "participant": {
    "upcoming_games": "Próximas sessões",
    "for_rank_games": "Para avaliação"
  },
  "roles": {
    "player": "Participante",
    "admin": "SuperAdmin (sistema)",
    "scoped_admin": "Administrador sênior",
    "observer": "Observador",
    "captain": "Capitão",
    "expert": "Especialista",
    "lead_expert": "Especialista sênior",
    "manager": "Gestor",
    "support": "Suporte",
    "early_access": "Acesso antecipado",
    "head": "Responsável",
    "candidate": "Candidato"
  },
  "user-status": {
    "active": "Ativo",
    "inactive": "Inativo",
    "pending": "Pendente"
  },
  "pagination": {
    "showing": "mostrando",
    "to": "a",
    "of": "de",
    "entries": "registros"
  },
  "validator": {
    "required": "Este campo é obrigatório",
    "library": "O tamanho do arquivo deve ser menor que 500MB",
    "email": "O campo Email deve conter um e-mail válido",
    "password": "O campo deve conter pelo menos uma maiúscula, minúscula, caractere especial e dígito, com no mínimo 8 caracteres",
    "confirm": "A confirmação do campo Confirmar senha não corresponde",
    "at_least": "O campo deve conter pelo menos",
    "items": "itens",
    "number": "Este campo deve ser um número inteiro",
    "is_odd": "Este campo deve ser par",
    "number_between": "Insira um número entre",
    "number_and": "e",
    "date_range_required": "Intervalo obrigatório",
    "invalid_date_range": "Intervalo inválido",
    "invalid_date_format": "Formato de data inválido",
    "start_date_after_end_date": "A data inicial deve ser anterior à data final",
    "max_180_days": "Máximo de 180 dias"
  },
  "user": {
    "menu": {
      "settings": "Configurações",
      "statistics": "Estatísticas",
      "logout": "Sair"
    }
  },
  "theme": {
    "system": "Sistema",
    "light": "Claro",
    "dark": "Escuro"
  },
  "error": {
    "default": "Desculpe, ocorreu um erro. Nossos especialistas já foram avisados e irão corrigir o problema o mais rápido possível.",
    "unauthorized": "Sua sessão expirou.",
    "contact-support": "Desculpe, ocorreu um erro. Entre em contato com o suporte técnico.",
    "forbidden": "Acesso negado"
  },
  "confirmation": {
    "sure": "Tem certeza de que deseja excluir o registro?",
    "sure_return_to_time_scheduling": "Tem certeza de que deseja retornar a sessão para a etapa de coordenação do horário de início?",
    "sure_restore": "Tem certeza de que deseja restaurar o registro?",
    "sure_mark_failed": "Marcar a partida como falhada e excluir permanentemente todas as avaliações e protocolos dos participantes?",
    "success": "Sucesso!",
    "deleted": "Excluído",
    "failed_marked": "Partida marcada como falhada",
    "restored": "Restaurado",
    "cancel": "Cancelado",
    "yes": "Sim",
    "no": "Não"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Bem-vindo de volta",
        "progress": "Seu progresso geral",
        "stats": {
          "minutes": "Minutos jogados",
          "effectiveness": "Pontuação geral",
          "completed_games_count": "Sessões concluídas",
          "total_games_count": "Total de sessões"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Ranking da empresa",
          "player": "Participante",
          "effectiveness": "Efetividade"
        }
      }
    },
    "head": {
      "my_stats": "Minhas estatísticas",
      "subordinates": "Meus subordinados",
      "subordinate_stats": "Estatísticas do subordinado",
      "select_subordinate": "Selecione um subordinado para ver as estatísticas",
      "no_subordinates": "Nenhum subordinado atribuído"
    }
  },
  "chat-page": {
    "last_game": "Última sessão",
    "chats": "Chats",
    "no-chats": "Nenhum chat encontrado",
    "contacts": "Contatos",
    "choose": "Escolha um contato",
    "send": "Enviar",
    "type": "Digite sua mensagem...",
    "no-contacts": "Nenhum contato encontrado",
    "search": "Pesquisar...",
    "start_conversation": "Iniciar conversa",
    "start_connecting": "Comece a se conectar com as pessoas selecionando um dos contatos à esquerda"
  },
  "scenarios-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "copy_title": "Copiar cenário",
    "generate_ai_title": "Gerar cenário com IA",
    "organization": "Empresa",
    "competence": "Competência",
    "actions": " ",
    "add": "Adicionar cenário",
    "ai-generate": "Gerar com IA",
    "copy": "Copiar cenário",
    "add_popup": "Adicionar cenário",
    "delete": "Excluir cenário",
    "edit": "Editar cenário",
    "edit_popup": "Editar cenário",
    "industries": [
      "FMCG/Varejo",
      "Farmacêutico",
      "Bancos e Fintech",
      "Hotéis e Turismo",
      "Empresas de TI/SaaS",
      "Restaurantes/HoReCa",
      "E-commerce/Marketplaces",
      "Manufatura/Indústria 4.0",
      "Logística e T&L",
      "Telecom",
      "Educação/EdTech",
      "Indústria química",
      "Software de gestão da cadeia de suprimentos",
      "Governo/Organizações sem fins lucrativos"
    ],
    "case_types": [
      "Liderança e Gestão de Pessoas",
      "Recrutamento e Avaliação de Pessoal",
      "Vendas e Atendimento ao Cliente",
      "Negociações e Influência",
      "Gestão de Conflitos",
      "Estratégia e Execução"
    ],
    "cases": [
      [
        "Definição de metas SMART/OKR",
        "Feedback de desenvolvimento (SBI/COIN)",
        "Delegação",
        "Coaching GROW",
        "Avaliação de desempenho",
        "Mentoria"
      ],
      [
        "Entrevista por competências (CBI)",
        "Avaliação/Assessment Center",
        "Sessão de integração (Onboarding)"
      ],
      [
        "Vendas clássicas de produto/serviço",
        "Tratamento de objeções",
        "Upsell/Cross-sell",
        "Tratamento de reclamações",
        "Vendas multicanal"
      ],
      [
        "Negociações internas de orçamento/recursos",
        "Contrato com cliente/fornecedor",
        "Negociações em crise"
      ],
      [
        "Conflito interpessoal na equipe",
        "Gestor-subordinado",
        "Conflito de valores/ética"
      ],
      [
        "Priorização de portfólio de projetos",
        "Gestão de mudanças",
        "Análise de riscos"
      ]
    ],
    "formats": [
      "1-1",
      "Equipes"
    ],
    "labels": {
      "industry": "Setor",
      "case_type": "Tipo de caso",
      "case": "Caso",
      "format": "Formato",
      "duration": "Duração (minutos)",
      "game_vs_ai": "Sessão vs IA",
      "level": "Nível",
      "competence": "Competência",
      "description": "Descrição do cenário",
      "description_hint": "Descreva opcionalmente o cenário que deseja gerar (máx. 4000 caracteres)"
    },
    "generating_in_progress": "Gerando cenário, por favor aguarde..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Tour",
      "full_name": "Participante",
      "games_count": "Sessões",
      "team": "Equipe",
      "export": "Exportar",
      "effectiveness": "Efetividade"
    }
  },
  "report-filters": {
    "department": "Departamento",
    "position": "Cargo",
    "employee": "Funcionário",
    "scenario": "Cenário",
    "competence": "Competência",
    "period": "Período",
    "reset": "Redefinir",
    "only-period-competence": "Apenas os filtros de período e competência são aplicados"
  },
  "competencies-page": {
    "title": "Título",
    "export-docx": "Export .docx",
    "skills": "Habilidades",
    "text": "Texto",
    "display_order": "Ordem",
    "ai-assistant": "Assistente de IA",
    "language": "Idioma",
    "department": "Departamento",
    "evaluation-target": "Quem estamos avaliando?",
    "evaluation-both": "Ambos participantes",
    "evaluation-team-a": "Somente equipe A",
    "evaluation-both-tooltip": "Ambos participantes são avaliados – adequado para cenários de negociação",
    "evaluation-team-a-tooltip": "Somente o líder é avaliado – formato de feedback",
    "actions": " ",
    "add": "Adicionar competência",
    "add_popup": "Adicionar competência",
    "delete": "Excluir competência",
    "edit": "Editar competência",
    "edit_popup": "Editar competência"
  },
  "faq-page": {
    "title": "Perguntas",
    "question": "Pergunta",
    "text": "Resposta",
    "is_shared": "Disponível para todas as empresas",
    "actions": " ",
    "visibility": "Visibilidade",
    "visible_to_all": "Visível para todos os usuários",
    "visible_to_managers": "Visível apenas para gerentes",
    "add": "Adicionar pergunta",
    "add_popup": "Adicionar pergunta",
    "delete": "Excluir pergunta",
    "edit": "Editar pergunta",
    "edit_popup": "Editar pergunta"
  },
  "ai-connectors-page": {
    "title": "Conectores de IA",
    "is_shared": "Disponível para todas as organizações",
    "actions": " ",
    "add": "Adicionar conector",
    "add_popup": "Adicionar conector",
    "delete": "Excluir conector",
    "edit": "Editar conector",
    "edit_popup": "Editar conector",
    "label": "Rótulo",
    "provider": "Provedor",
    "service": "Serviço",
    "organization": "Organização",
    "status": "Status",
    "region": "Região",
    "endpoint": "Endpoint",
    "secret": "Senha/Chave",
    "maxConcurrency": "Concorrência máxima",
    "timeoutSec": "Timeout",
    "sortOrder": "Ordem",
    "config": "Configuração",
    "modelPrimary": "Modelo primary",
    "modelLight": "Modelo light",
    "modelLightHint": "Vazio: as chamadas light usam o modelo primary",
    "folderId": "ID do folder",
    "models": "Modelos",
    "is_default": "Padrão",
    "notes": "Notas"
  },
  "skills-page": {
    "title": "Título",
    "display_order": "Ordem",
    "competence": "Competência",
    "text": "Indicadores",
    "actions": " ",
    "add": "Adicionar habilidade",
    "add_popup": "Adicionar habilidade",
    "delete": "Excluir habilidade",
    "edit": "Editar habilidade",
    "edit_popup": "Editar habilidade"
  },
  "departments-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar departamento",
    "add_popup": "Adicionar departamento",
    "delete": "Excluir departamento",
    "edit": "Editar departamento",
    "edit_popup": "Editar departamento"
  },
  "tours-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar tour",
    "add_popup": "Adicionar tour",
    "delete": "Excluir tour",
    "edit": "Editar tour",
    "edit_popup": "Editar tour"
  },
  "library-page": {
    "title": "Título",
    "text": "Descrição",
    "video": "Vídeo",
    "courses": "Cursos",
    "video_link_copy": "Copiar link",
    "video_in_process": "O vídeo está sendo processado...",
    "is_public": "É público",
    "actions": " ",
    "add": "Adicionar vídeo",
    "add_popup": "Adicionar vídeo",
    "delete": "Excluir vídeo",
    "edit": "Editar vídeo",
    "edit_popup": "Editar vídeo"
  },
  "library-documents-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar documento",
    "add_popup": "Adicionar documento",
    "delete": "Excluir documento",
    "edit": "Editar documento",
    "edit_popup": "Editar documento",
    "file": "Arquivo"
  },
  "scorm-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar curso",
    "loading": "O curso está sendo carregado...",
    "add_popup": "Adicionar curso",
    "delete": "Excluir curso",
    "edit": "Editar curso",
    "edit_popup": "Editar curso",
    "zip_file": "Arquivo ZIP"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Descrição",
    "actions": " ",
    "add": "Adicionar assistente de IA",
    "add_popup": "Adicionar assistente de IA",
    "delete": "Excluir assistente de IA",
    "edit": "Editar assistente de IA",
    "edit_popup": "Editar assistente de IA"
  },
  "ai-prompts-page": {
    "name": "Nome",
    "content": "Conteúdo",
    "actions": " ",
    "add": "Adicionar prompt de IA",
    "add_popup": "Adicionar prompt de IA",
    "delete": "Excluir prompt de IA",
    "edit": "Editar prompt de IA",
    "edit_popup": "Editar prompt de IA",
    "key": "Chave do slot",
    "model": "Modelo",
    "updated_at": "Atualizado",
    "custom": "Personalizado",
    "description": "Descrição",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Esforço de raciocínio",
    "reasoning_effort_default": "Padrão",
    "required_placeholders": "Marcadores de posição obrigatórios (devem estar presentes no conteúdo)",
    "versions": "Histórico de versões",
    "no_versions": "Ainda não há versões",
    "restore": "Restaurar",
    "restore_confirm": "Restaurar esta versão? O conteúdo dela passará a ser o atual.",
    "restored": "Versão restaurada",
    "current_version": "Atual",
    "author": "Autor",
    "error": "Algo deu errado.",
    "tab_system": "Sistema",
    "tab_custom": "Personalizado",
    "system_hint": "Os prompts do sistema são usados pelo código da plataforma. Não podem ser excluídos, mas seu conteúdo pode ser editado.",
    "custom_hint": "Os prompts personalizados são associados a competências e perfis de IA como substituição do prompt de avaliação.",
    "model_from_code": "definido pelo código",
    "model_from_code_hint": "O modelo é escolhido pelo código que consome o prompt; não é armazenado no próprio prompt.",
    "used_by": "Usado por",
    "used_by_value": "Competências: {competencies}, Perfis de IA: {profiles}",
    "not_used": "Sem uso",
    "delete_blocked_hint": "Não é possível excluir: o prompt é usado como substituição. {usage}",
    "slot_description": {
      "game_eval_negotiation": "Avaliação por IA de sessões PvP: negociação",
      "game_eval_feedback": "Avaliação por IA de sessões PvP: feedback",
      "game_eval_vs_ai": "Avaliação por IA de sessões vs IA (quando o perfil de IA não tem substituição)",
      "protocol_evaluation": "Preencher o protocolo do cenário a partir da transcrição de uma sessão vs IA",
      "voice_agent": "Prompt do sistema para o agente de voz de IA",
      "scenario_generation": "Geração do cenário a partir da descrição",
      "scenario_card_update": "Atualização do cartão do cenário a partir da descrição da IA",
      "scenario_optimize": "Otimização da descrição da IA de um cenário",
      "skill_report_analysis": "Relatório de habilidades: etapa de análise",
      "skill_report_recommendations": "Relatório de habilidades: etapa de recomendações"
    }
  },
  "ai-profiles-page": {
    "name": "Nome",
    "settings": "Configurações",
    "temperature": "Criatividade",
    "demeanor": "Postura",
    "behavior": "Comportamento, instruções",
    "background": "Biografia",
    "style": "Estilo",
    "instructions": "Instruções",
    "supportive_phrases": "Frases de apoio",
    "ai_assistant": "Assistente de IA",
    "ai_starts_first": "IA começa primeiro",
    "first_phrase": "Primeira frase",
    "closing_phrases": "Frases de encerramento",
    "voice": "Voz",
    "expert_mode": "Modo especialista",
    "custom_demeanor_hint": "Comportamento personalizado atual",
    "is_shared": "Disponível para todas as organizações",
    "voice_options": {
      "male": "Masculino",
      "female": "Feminino"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Amigável",
        "description": "Acessível e agradável"
      },
      "critical": {
        "title": "Crítico",
        "description": "Aponta frequentemente falhas e áreas de melhoria"
      },
      "empathetic": {
        "title": "Empático",
        "description": "Muito sensível aos sentimentos e emoções dos outros"
      },
      "enthusiastic": {
        "title": "Entusiasmado",
        "description": "Demonstra grande entusiasmo e animação"
      },
      "analytical": {
        "title": "Analítico",
        "description": "Focado em lógica e resolução detalhada de problemas"
      },
      "curious": {
        "title": "Curioso",
        "description": "Gosta de aprender e fazer perguntas"
      },
      "assertive": {
        "title": "Assertivo",
        "description": "Confiante e seguro de si"
      },
      "blunt": {
        "title": "Direto",
        "description": "Direto ao ponto"
      },
      "skeptical": {
        "title": "Cético",
        "description": "Desconfiado de novas soluções e ideias"
      },
      "neutral": {
        "title": "Neutro",
        "description": "Equilibrado e objetivo no estilo de comunicação"
      },
      "casual": {
        "title": "Informal",
        "description": "Tono descontraído e conversacional"
      }
    },
    "placeholders": {
      "name": "Por exemplo: Sérgio (educado e amigável)",
      "demeanor": "Por exemplo: Amigável, educado e sociável...",
      "background": "Por exemplo: Já foi demitido duas vezes...",
      "behavior": "Por exemplo: Não interrompe, escuta ativamente...",
      "first_phrase": "Por exemplo: Bom dia! Como está o seu humor?",
      "closing_phrases": "Por exemplo: Nosso tempo está quase acabando, então sugiro que resumamos rapidamente nossa reunião."
    },
    "actions": " ",
    "add": "Adicionar perfil de IA",
    "add_popup": "Adicionar perfil de IA",
    "subtitle": "Como o interlocutor aparece e soa na sessão",
    "preview": {
      "title": "Pré-visualização",
      "unnamed": "Sem nome",
      "voice": "voz {name}",
      "defaultVoice": "voz padrão",
      "defaultPhoto": "Foto padrão",
      "listen": "Ouvir a voz",
      "defaultVoiceNotice": "A voz será escolhida no início da sessão — não é possível ouvi-la antes",
      "photoPlaceholder": "A foto aparecerá aqui"
    },
    "delete": "Excluir perfil de IA",
    "edit": "Editar perfil de IA",
    "edit_popup": "Editar perfil de IA",
    "avatar_hint": "imagem do avatar",
    "avatar_save_first": "Salve o perfil primeiro para habilitar o envio de avatar",
    "avatar_requirements": "Máx. 1 MB • Recomendado: 1536×1024 • Proporção: 3:2",
    "max_characters": "Máximo de {max} caracteres"
  },
  "games-page": {
    "game-with-ai": "Sessão de papéis com IA",
    "organization": "Organização",
    "status": "Status",
    "failure_reasons": {
      "protocol_not_agreed": "Os participantes não chegaram a um acordo sobre o protocolo de avaliação",
      "protocol_approval_expired": "O tempo de aprovação do protocolo expirou",
      "annulled": "A sessão foi anulada pelo administrador",
      "expired": "O tempo da sessão expirou",
      "assignment_changed": "A atribuição do curso mudou no sistema de aprendizagem"
    },
    "restore": "Restaurar",
    "play": "Jogar",
    "meetings_unavailable": "As sessões de vídeo entre os participantes estão temporariamente indisponíveis. Tente novamente mais tarde.",
    "import": "Importar",
    "scenario": "Cenário",
    "tour": "Tour",
    "game_types": {
      "classic": "Modo clássico",
      "vs_ai": "Sessão de papéis com IA",
      "uploaded_recording": "Gravação"
    },
    "upload_recording": {
      "file": "Arquivo da gravação",
      "file_hint": "Vídeo ou áudio, até 1 GB",
      "uploaded": "Arquivo enviado",
      "file_too_large": "Arquivo excede 1 GB",
      "upload_error": "Falha ao enviar o arquivo",
      "player": "Participante",
      "rate_both": "Avaliar ambos participantes",
      "second_player": "Segundo participante",
      "open_session": "Abrir sessão"
    },
    "game_targets": {
      "user": "Participante",
      "position": "Cargo",
      "department": "Departamento"
    },
    "number": "Número",
    "start_up_to": "Iniciar até",
    "start_time": "Horário de início",
    "teamA": "Equipe A",
    "teamB": "Equipe B",
    "others": "Participantes",
    "actions": " ",
    "edit_results": "Alterar resultados",
    "add": "Adicionar sessão",
    "add_popup": "Adicionar sessão",
    "delete": "Excluir sessão",
    "edit": "Editar sessão",
    "edit_popup": "Editar sessão",
    "time_scheduling": "Agendamento do horário de início",
    "return_to_time_scheduling": "Retornar ao agendamento do horário de início",
    "preparation": "Preparação para a sessão",
    "view_scenario": "Ver cenário",
    "protocol": "Aprovação do protocolo",
    "not_agreed": "Não acordado",
    "expert-accept": "Aceitar e prosseguir para avaliação",
    "expert-decline": "Recusar",
    "hide_ai_results": "Ocultar resultados da IA",
    "show_ai_results": "Mostrar resultados da IA",
    "mark_failed": "Marcar como falhada",
    "popup": {
      "start_up_to": "Iniciar até",
      "target": "Para quem atribuir a sessão?",
      "custom_field_value": "Valor de “{field}”",
      "target_preview_count": "Sessões a serem criadas: {count}",
      "target_preview_empty": "Nenhum jogador corresponde a este segmento — nenhuma sessão será criada",
      "target_preview_limit_exceeded": "Isso é mais do que uma atribuição pode criar (no máximo {limit}). Reduza o recorte, o número de casos ou o número de cópias",
      "copies_per_player": "Cópias de cada caso por jogador",
      "position": "Cargo",
      "department": "Departamento",
      "scenario": "Cenário",
      "optional": "Opcional, pode ser omitido",
      "protocol_time": "Tempo do protocolo",
      "protocol_time_hint": "Número entre 1 e 1440",
      "preparation_time": "Tempo de preparação",
      "preparation_time_hint": "Em minutos",
      "game_duration": "Duração da sessão",
      "game_duration_hint": "Número entre 1 e 60",
      "is_team": "Cenário para equipes",
      "is_camera_required": "Câmeras dos participantes são obrigatórias",
      "is_self_rated": "Os participantes podem se autoavaliar",
      "is_each_other_rated": "Os participantes podem avaliar uns aos outros",
      "is_expert_rated": "Avaliação por especialista disponível",
      "is_ai_rated": "Avaliação por IA disponível",
      "show_results": "Mostrar resultados",
      "automatically": "automaticamente",
      "manually": "manualmente",
      "is_public_hint": "Qualquer observador poderá se conectar",
      "is_public": "Sessão pública",
      "team_a": "Equipe A",
      "team_b": "Equipe B",
      "player_a": "Participante A",
      "player_b": "Participante B",
      "expert": "Especialista",
      "observers": "Observadores",
      "tour": "Tour",
      "search": "Pesquisar...",
      "choose_players": "Escolher participantes",
      "choose_expert": "Escolher especialista",
      "choose_observers": "Escolher observadores",
      "choose_scenario": "Escolher cenário",
      "choose_tour": "Escolher tour",
      "expert_empty": "Se não selecionado, o capitão poderá escolher",
      "captain": "Capitão",
      "": "",
      "protocol": {
        "title": "Aprovação do protocolo",
        "target": "Objetivo",
        "await_approval": "Aguardando aprovação do oponente",
        "await_proposal": "Aguardando proposta do oponente",
        "questions": "Perguntas para sua equipe",
        "questions_a": "Perguntas para equipe A",
        "questions_b": "Perguntas para equipe B",
        "not_agreed": "Não chegaram a um acordo",
        "not_agreed_confirm": "A sessão terminará sem sucesso e os resultados não serão contabilizados. Esta ação é irreversível.",
        "not_agreed_done": "A sessão terminou sem sucesso."
      },
      "start_time": {
        "title": "Horário de início",
        "must_start_by": "Deve começar até"
      },
      "edit_results": {
        "title": "Alterar resultados"
      },
      "preparation": {
        "title": "Preparação para a sessão",
        "description": "Descrição",
        "description_team": "Descrição da equipe",
        "notes": "Notas pessoais"
      },
      "import": {
        "download_example": "Baixar exemplo",
        "title": "Importação de sessões",
        "button": "Iniciar importação",
        "label": "Arquivo Excel"
      },
      "create_multi_scenario_games_immediately": "Todas as sessões serão criadas imediatamente",
      "create_multi_scenario_games_sequentially": "As sessões serão criadas sequencialmente (após a conclusão bem-sucedida de cada uma)"
    }
  },
  "ai-game": {
    "title": "Sessão de papéis com IA",
    "recording": "Gravação",
    "ai": "IA",
    "you": "Você",
    "ai_ready": "Pronto",
    "camera_off": "Câmera desligada",
    "stop_game": "Encerrar sessão",
    "start_game": "Iniciar sessão",
    "mic_permission": "Conceda permissão para o microfone nas configurações para iniciar a sessão",
    "permissions_granted": "Permissões concedidas com sucesso!",
    "close": "Fechar",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Ligue o microfone para iniciar a sessão",
    "mic_not_detected": "Nenhum som detectado ainda — tente falar ou verifique seu microfone",
    "permissions_needed": "Acesso ao microfone é obrigatório. Câmera é opcional",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Tem certeza? A sessão não pode ser pausada",
      "start_title": "Sessão iniciada",
      "start_success": "A sessão foi iniciada com sucesso",
      "start_cancel_title": "Sessão não iniciada",
      "start_cancel_msg": "O início da sessão foi cancelado",
      "end_question": "Tem certeza? A sessão será encerrada",
      "end_title": "Sessão encerrada",
      "end_success": "A sessão foi encerrada com sucesso",
      "end_cancel_title": "Sessão não encerrada",
      "end_cancel_msg": "O encerramento da sessão foi cancelado"
    },
    "voice": {
      "disconnected": "Desconectado",
      "connecting": "Conectando...",
      "connected": "Conectado ao servidor",
      "connection_error": "Falha ao conectar ao agente de voz",
      "game_already_finished": "Este jogo já foi finalizado",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Nenhuma sala disponível no momento. Por favor, tente novamente mais tarde.",
      "preparing_recording": "Preparando a gravação, nova tentativa em {seconds}s…",
      "recording_service_overloaded": "O serviço de gravação está sobrecarregado. Por favor tente novamente em alguns minutos.",
      "session_quota_exhausted": "O pacote de sessões da sua organização foi esgotado. Por favor, entre em contato com seu gestor.",
      "connection_blocked": "Sua rede bloqueou a criação da conexão com a IA. Permita HTTPS (443) para os domínios necessários e tente novamente.",
      "connection_blocked_signaling": "O firewall ou proxy da sua rede está bloqueando a conexão com o servidor de voz. Tente se conectar de outra rede ou de um hotspot móvel.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "Acesso à câmera ou ao microfone foi negado. Vá para Ajustes do Safari > Sites > Câmera/Microfone e permita acesso para este site.",
    "supported": "Navegador suportado"
  },
  "positions-page": {
    "title": "Título",
    "actions": " ",
    "add": "Adicionar cargo",
    "add_popup": "Adicionar cargo",
    "delete": "Excluir cargo",
    "edit": "Editar cargo",
    "edit_popup": "Editar cargo"
  },
  "user-custom-fields-page": {
    "title": "Título",
    "type": "Tipo",
    "options_count": "Valores",
    "actions": " ",
    "add": "Adicionar campo",
    "add_popup": "Adicionar campo",
    "delete": "Excluir campo",
    "delete_confirm": "Excluir o campo? Os valores salvos nos usuários deixarão de ser exibidos.",
    "edit": "Editar campo",
    "edit_popup": "Editar campo",
    "empty": "Ainda não há campos personalizados",
    "error": "Não foi possível salvar o campo",
    "type_text": "Texto",
    "type_select": "Lista",
    "type_locked_hint": "O tipo não pode ser alterado depois que o campo é criado",
    "options": "Valores",
    "options_hint": "A ordem dos valores aqui é a ordem na lista suspensa",
    "options_required": "Adicione pelo menos um valor",
    "option_title": "Valor",
    "option_add": "Adicionar valor",
    "option_delete": "Excluir valor",
    "option_delete_confirm": "Excluir o valor? Ele será limpo nos usuários que o tinham selecionado.",
    "option_move_up": "Mover para cima",
    "option_move_down": "Mover para baixo"
  },
  "organizations-page": {
    "name": "Nome",
    "host": "Host",
    "duel_limit": "Limite de duelos",
    "max_users": "Máx. usuários",
    "max_users_hint": "0 = ilimitado",
    "max_vs_ai_games_per_scenario": "Máx. jogos de IA por jogador por cenário",
    "max_vs_ai_games_per_scenario_hint": "Vazio = sem limite. Aplica-se à criação de jogos por iniciativa do jogador",
    "employee_report_daily_limit": "Limite de relatórios de funcionários por dia",
    "employee_report_daily_limit_hint": "Vazio = limite geral da plataforma. Aplica-se a gestores e responsáveis",
    "employee_report_hourly_limit": "Limite de relatórios de funcionários por hora",
    "employee_report_hourly_limit_hint": "Vazio = limite geral da plataforma. Aplica-se a gestores e responsáveis",
    "registration": "Registro aberto",
    "timezone": "Fuso horário",
    "locale": "Localização",
    "users_count": "Usuários",
    "actions": " ",
    "add": "Adicionar organização",
    "add_popup": "Adicionar organização",
    "delete": "Excluir organização",
    "edit": "Editar organização",
    "edit_popup": "Editar organização",
    "available_languages": "Idiomas disponíveis",
    "show_game_numbers_for_player": "Mostrar números das sessões para o participante",
    "allow_players_choose_expert": "Permitir que os participantes escolham o especialista",
    "send_message": "Enviar mensagem aos gerentes",
    "message": "Mensagem",
    "send": "Enviar",
    "clear_message": "Limpar mensagem",
    "current_message": "Mensagem atual",
    "two_factor_method": "Autenticação de dois fatores",
    "two_factor_disabled": "Desativada",
    "two_factor_email": "E-mail",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Ocultar resultados da IA",
    "hide_player_rating": "Ocultar o ranking da empresa dos participantes",
    "show_character_memory_to_player": "Mostrar a memória do personagem ao jogador",
    "show_meeting_recap_to_player": "Mostrar o resumo da reunião ao jogador",
    "create_user_on_external_launch": "Criar um usuário na primeira solicitação de um sistema externo",
    "create_user_on_external_launch_hint": "Quando desativado, um participante que chega pela primeira vez pelo sistema externo é recusado em vez de receber um jogo. Cada usuário criado dessa forma ocupa uma vaga na assinatura.",
    "allow_external_email_linking": "Permitir vincular um usuário externo por e-mail",
    "allow_external_email_linking_hint": "Quando ativado, uma pessoa externa é associada a um funcionário já existente se o sistema externo informou o e-mail a partir do próprio servidor. Quando desativado, essa solicitação é recusada e nenhum segundo usuário com o mesmo e-mail é criado."
  },
  "users-page": {
    "import": "Importar",
    "user": "Usuário",
    "roles": "Funções",
    "effectiveness": "Efetividade",
    "department": "Departamento",
    "position": "Cargo",
    "status": "Status",
    "actions": " ",
    "add": "Adicionar usuário",
    "add_popup": "Novo usuário",
    "last_login_at": "Último login",
    "delete": "Excluir",
    "view": "Ver",
    "login": "Login",
    "message": "Mensagem",
    "activate": "Ativar",
    "deactivate": "Bloquear",
    "edit_popup": "Editar usuário",
    "total_in_org": "Total na organização",
    "multi_role_note": "Um usuário com várias funções é contabilizado em cada distintivo",
    "filter_role": "Função",
    "all_roles": "Todas as funções",
    "filter_activity": "Cenários concluídos",
    "activity_played": "Sim",
    "activity_not_played": "Não",
    "filter_activity_from": "Jogado desde",
    "filter_last_login_from": "Data do login",
    "filter_custom_field": "Campo personalizado",
    "filter_custom_field_value": "Valor de “{field}”",
    "last_login_never": "Nunca fez login",
    "last_login_since": "Fez login desde",
    "cases_progress": "Casos concluídos",
    "cases_progress_value": "{completed} de {assigned}",
    "export": "Exportar",
    "popup": {
      "name": "Nome",
      "last_name": "Sobrenome",
      "patronymic": "Nome do meio",
      "phone": "Telefone",
      "timezone": "Fuso horário",
      "language": "Idioma",
      "country": "País",
      "invalid_phone": "Número de telefone incorreto",
      "department": "Departamento",
      "position": "Cargo",
      "effectiveness": "Efetividade",
      "roles": "Funções",
      "organizations": "Organizações",
      "blocked": "Bloqueado",
      "is_active": "Está ativo",
      "email_verified": "E-mail verificado",
      "email_not_verified": "E-mail não verificado",
      "subordinates": "Subordinados",
      "search_subordinates": "Pesquisar participantes...",
      "import": {
        "download_example": "Baixar exemplo",
        "title": "Importação de usuários",
        "button": "Iniciar importação",
        "label": "Arquivo Excel",
        "marker_hint": "Para um usuário que já existe, uma célula vazia mantém o valor atual e um traço (-) limpa o campo.",
        "result_title": "Importação iniciada",
        "result_created": "Serão criados: {count}",
        "result_updated": "Serão atualizados: {count}",
        "result_skipped": "Ignoradas: {count}",
        "result_skipped_row": "Linha {row}, {email}: {reason}",
        "result_truncated": "…e mais {count} linhas ignoradas"
      }
    }
  },
  "users-ranking-page": {
    "user": "Usuário",
    "roles": "Funções",
    "effectiveness": "Efetividade",
    "average-effectiveness": "Média por sessão",
    "sessions-count": "Sessões",
    "department": "Departamento",
    "position": "Cargo",
    "status": "Status",
    "export": "Exportar",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Sessões concluídas",
    "not_found": "Usuário não encontrado",
    "games_total": "Total",
    "username": "Nome de usuário",
    "phone": "Telefone",
    "status": "Status",
    "language": "Idioma",
    "timezone": "Fuso horário",
    "edit": "Editar",
    "department": "Departamento",
    "position": "Cargo",
    "activate": "Ativar",
    "block": "Bloquear",
    "account": {
      "title": "Conta",
      "summary": {
        "title": "Resumo",
        "games": "Sessões realizadas",
        "place": "Posição",
        "effectiveness": "Efetividade",
        "time": "Tempo"
      }
    },
    "security": {
      "title": "Segurança",
      "change_password_title": "Alterar senha",
      "change_password": "Alterar senha",
      "new_password": "Nova senha",
      "confirm_new_password": "Confirmar nova senha",
      "password_requirements": "Requisitos de senha:",
      "password_requirements_1": "Pelo menos 8 caracteres – quanto mais, melhor",
      "password_requirements_2": "Pelo menos um caractere minúsculo",
      "password_requirements_3": "Pelo menos um número, símbolo ou espaço em branco"
    },
    "statistics": {
      "title": "Estatísticas"
    }
  },
  "game": {
    "character_memory": {
      "title": "Do que o personagem se lembra",
      "subtitle": "A memória de reuniões passadas com a qual o personagem chega a este jogo",
      "preview_subtitle": "A memória ainda não foi registrada: o personagem vai recebê-la no momento em que o jogo começar",
      "unavailable": "A reunião anterior não está disponível para o personagem: ele vai iniciar a conversa sem se lembrar dela.",
      "agreements": "Acordos",
      "player_commitments": "Compromissos do jogador",
      "character_commitments": "Compromissos do personagem",
      "open_issues": "Questões em aberto",
      "facts": "Fatos mencionados",
      "attitude": "Atitude em relação ao jogador",
      "evaluation_passed": "Os resultados da avaliação daquela reunião foram repassados ao personagem",
      "evaluation_not_ready": "A avaliação daquela reunião ainda não está pronta: o personagem vai recebê-la assim que for calculada.",
      "evaluation_hidden": "Os textos da avaliação estão ocultos pelas configurações da organização.",
      "overall_effectiveness": "Eficácia geral",
      "outcome": {
        "deal": "Acordo",
        "partial": "Parcial",
        "no_deal": "Sem acordo",
        "unclear": "Pouco claro"
      }
    },
    "meeting_recap": {
      "title": "Resumo da reunião",
      "outcome": "Resultado",
      "agreements": "Acordos",
      "player_commitments": "Compromissos do jogador",
      "character_commitments": "Compromissos do personagem",
      "open_issues": "Questões em aberto",
      "facts": "Fatos mencionados",
      "pending": "O resumo da reunião ainda está sendo preparado. Volte a verificar um pouco mais tarde.",
      "unavailable": "Não foi possível montar o resumo desta reunião.",
      "none": "Não há resumo para este jogo."
    },
    "title": "Sessão",
    "team": "Equipe",
    "expert": "Especialista",
    "points": "pontos",
    "your_result": "Seu resultado",
    "joined_at": "Entrou em:",
    "ended_at": "Data de conclusão",
    "min": "min.",
    "duration": "Duração",
    "from_average": "da média",
    "ai_expert": "Especialista IA",
    "ai_evaluation_in_progress": "Avaliação da IA em andamento",
    "delete_ai_request": "Excluir feedback da IA",
    "ai_expert_refresh": "Atualizar resultados da IA",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Não é possível atualizar os resultados da IA agora: a avaliação da IA ainda está em andamento.",
      "answer_pending": "Não é possível atualizar os resultados da IA agora: a resposta da IA ainda não chegou.",
      "recognition_pending": "Não é possível atualizar os resultados da IA agora: a gravação ainda está sendo transcrita.",
      "recognition_has_no_speech": "Nenhuma fala foi reconhecida na gravação, portanto não é possível atualizar os resultados da IA.",
      "recognition_has_too_little_speech": "Quase não há conversa entre os participantes na gravação, portanto a avaliação da IA não foi realizada.",
      "no_ai_evaluation": "Esta sessão não tem mais avaliação da IA.",
      "game_evaluation_blocked": "A sessão não ocorreu ou foi anulada, portanto a avaliação da IA não está disponível."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Nenhuma fala foi reconhecida na gravação, portanto a avaliação da IA não foi realizada.",
      "recognition_has_too_little_speech": "Quase não há conversa entre os participantes na gravação, portanto a avaliação da IA não foi realizada.",
      "game_evaluation_blocked": "A sessão não ocorreu ou foi anulada, portanto a avaliação da IA não está disponível."
    },
    "ai_expert_refresh_failed": "Não foi possível atualizar os resultados da IA.",
    "speaker_mapping": {
      "title": "Participantes e vozes",
      "voice": "Voz {number}",
      "unknown": "Não identificado",
      "needs_review": "Verifique os participantes",
      "needs_review_hint": "Os participantes podem ter sido identificados incorretamente: verifique se o feedback da IA chegou às pessoas certas.",
      "failed": "Não foi possível identificar os participantes automaticamente.",
      "unavailable": "O provedor de IA estava indisponível; os participantes serão identificados na próxima avaliação.",
      "empty": "A transcrição não tem falas para identificar os participantes.",
      "corrected_manually": "Corrigido manualmente",
      "under_reevaluation": "A avaliação da IA está em andamento com estes participantes. Até que termine, a página mostra os resultados anteriores.",
      "confirm": "Os participantes estão corretos",
      "review": "Verificar",
      "dialog_hint": "Atribua um participante a cada voz. Após salvar, o feedback da IA será solicitado novamente.",
      "save": "Salvar",
      "cancel": "Cancelar",
      "confirmed": "Participantes confirmados",
      "fixed": "Participantes corrigidos, feedback da IA solicitado novamente",
      "action_failed": "Não foi possível concluir a ação"
    },
    "ai_expert_created": "O processo de avaliação da sessão foi iniciado. Isso levará alguns minutos. Você pode sair da página, pois enviaremos uma notificação quando a avaliação estiver disponível.",
    "expert_already_requested": "A avaliação já foi solicitada por outro participante",
    "request_expert": "Solicitar especialista",
    "assign_expert": "Atribuir especialista",
    "ai_process": "Aguarde, processando",
    "analyzing_results": "Analisando resultados da sessão...",
    "complete_expert_request": "Concluir avaliação",
    "tabs": {
      "description": {
        "title": "Descrição do Cenário",
        "subtitle": "Informações e regras da sessão",
        "situation": "Situação",
        "your_role": "Seu papel",
        "player_role": "Papel do participante: {name}",
        "team_tab": "Equipe {team}",
        "empty": "Esta sessão não tem descrições.",
        "load_error": "Não foi possível carregar a descrição. Tente novamente mais tarde."
      },
      "results": {
        "title": "Resultados",
        "effectiveness_summary": "Eficácia da equipe",
        "your_effectiveness": "Sua eficácia",
        "parameters_section": "Parâmetros",
        "parameter": "Parâmetro",
        "target": "Objetivo",
        "coefficient": "Coeficiente",
        "value": "Acordo",
        "points": "Pontos",
        "points_short": "pontos",
        "combinations": "Combinações",
        "combination_bonus": "Bônus de combinação",
        "questions": "Perguntas",
        "question": "Pergunta",
        "answer": "Resposta",
        "total": "Total"
      },
      "comments": {
        "title": "Análise em vídeo",
        "comments": "Comentários",
        "no_comments": "Ainda não há comentários",
        "no_video": "Vídeo indisponível",
        "video_processing": "O vídeo está sendo processado...",
        "count": "comentários",
        "delete": "Excluir",
        "edit": "Editar",
        "popup": {
          "add": "Adicionar comentário",
          "edit": "Editar comentário",
          "comment": "Comentário",
          "player": "Participante",
          "all": "Para todos"
        }
      },
      "feedback": {
        "title": "Avaliação da sessão",
        "no_feedback": "Ainda não há avaliações",
        "no_feedback_description": "O feedback para esta sessão ainda não foi adicionado",
        "overall_score": "Pontuação Geral",
        "skills_evaluated": "{count} habilidades avaliadas",
        "no_comment": "Sem comentário",
        "score_button": "Avaliar participante",
        "player": "Participante",
        "author": "Autor",
        "download": "Baixar vídeo",
        "download_transcript": "Baixar transcrição",
        "evaluators": {
          "ai": "Especialista",
          "expert": "Especialista",
          "player": "Participante",
          "manager": "Gestor",
          "head": "Responsável"
        },
        "popup": {
          "score": {
            "title": "Avaliação do participante",
            "comment": "Comentário",
            "error": "Você deve avaliar todas as habilidades do participante",
            "save_error": "Não foi possível salvar a avaliação. Você pode não ter permissão para avaliar este participante."
          }
        }
      },
      "checklist": {
        "title": "Lista de verificação",
        "total": "Itens aprovados",
        "pass": "Aprovado",
        "fail": "Reprovado",
        "cannot_assess": "Não é possível avaliar",
        "comment": "Comentário geral",
        "category": "Categoria",
        "author": "Avaliador",
        "player": "Participante",
        "passed_of": "{passed} de {total}",
        "evidence": "Evidência",
        "rationale": "Justificativa",
        "no_results": "Ainda não há avaliação da lista de verificação",
        "no_results_description": "Esta sessão ainda não foi avaliada com uma lista de verificação"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Criar novo",
        "edit_ai_profile": "Editar",
        "delete_ai_profile": "Excluir",
        "confirm_delete_ai_profile": "Tem certeza de que deseja excluir este perfil de IA?",
        "first_header": "Configurações básicas",
        "second_header": "Participante IA",
        "third_header": "Descrição do cenário",
        "is_public": "Público",
        "is_public_hint": "Se ativado, o cenário ficará disponível para seleção pelos participantes.",
        "title": "Informações",
        "subtitle": "Dados básicos do cenário",
        "image": "imagem do cenário",
        "field_title": "Título",
        "competence": "Competência",
        "description": "Descrição",
        "description_a": "Descrição para equipe A",
        "description_b": "Descrição para equipe B",
        "next_scenario_label": "Próximo cenário",
        "next_scenario_placeholder": "Não selecionado",
        "next_scenario_hint": "Após concluir a sessão com este cenário, será criada automaticamente uma sessão com o próximo cenário.",
        "memory_header": "Conexão com a próxima reunião",
        "memory_group_evaluation": "A avaliação da próxima reunião",
        "memory_group_character": "O personagem da próxima reunião",
        "memory_pass_to_next": "se lembra desta reunião",
        "memory_pass_to_next_hint": "O personagem do próximo cenário inicia a conversa como se já conhecesse o jogador: ele recebe um resumo breve desta reunião, os acordos, os compromissos das duas partes, as questões em aberto e os fatos mencionados. A gravação e as citações literais não são repassadas a ele. Ative esta opção quando a próxima reunião for uma continuação desta: uma segunda rodada de negociação, uma reunião individual recorrente.",
        "memory_pass_evaluation_to_next": "conhece a avaliação desta reunião",
        "memory_pass_evaluation_to_next_hint": "Junto com a memória, o personagem recebe os textos de feedback sobre as competências e o resultado geral desta reunião, podendo agir como um coach que se lembra do que o jogador fez bem.",
        "memory_evaluate_next_with_agreements": "considera os acordos desta reunião",
        "memory_evaluate_next_with_agreements_hint": "Ao avaliar a próxima reunião, o especialista em IA verá os acordos, os compromissos das duas partes e as questões em aberto desta reunião, podendo verificar se o jogador cumpriu o que prometeu. As notas e os textos da avaliação anterior não são repassados, para que não influenciem a nova avaliação.",
        "ai_profile": "Perfil de IA",
        "ai_profile_placeholder": "Somente para sessões com IA",
        "ai_description": "Descrição da IA",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Escrever um prompt de IA eficaz requer experiência. Um prompt mal escrito pode levar a um comportamento imprevisível do cenário. Se não tiver certeza, use o botão «Otimizar com IA», experimente a geração de cenários ou consulte seu gerente.",
        "knowledge_base_header": "Base de Conhecimento",
        "knowledge_base_documents": "Documentos da Base de Conhecimento",
        "knowledge_base_documents_hint": "Anexe documentos para fornecer contexto ao jogador de IA",
        "knowledge_base_no_documents": "Nenhum documento disponível. Faça upload de documentos na página \"Base de Conhecimento\".",
        "knowledge_base_chunks": "{count} fragmentos",
        "knowledge_base_purpose_voice": "Sessão de IA",
        "knowledge_base_purpose_eval": "Avaliação"
      },
      "settings": {
        "title": "Configurações",
        "subtitle": "Configuração do cenário",
        "min_players": "Mínimo de participantes",
        "min_players_hint": "Número entre 2 e 20",
        "max_players": "Máximo de participantes",
        "max_players_hint": "Número entre 2 e 20",
        "protocol_time": "Tempo de protocolo (min)",
        "protocol_time_hint": "Número entre 1 e 1440",
        "preparation_time": "Tempo de preparação (min)",
        "preparation_time_hint": "Número entre 0 e 1440. 0 – a descrição fica visível imediatamente",
        "game_duration": "Duração da sessão (min)",
        "game_duration_hint": "Número entre 1 e 60",
        "is_team": "Cenário para equipes",
        "is_camera_required": "Câmeras dos participantes são obrigatórias",
        "is_self_rated": "Participantes podem se autoavaliar",
        "is_each_other_rated": "Participantes podem avaliar uns aos outros",
        "is_expert_rated": "Avaliação por especialista disponível",
        "is_ai_rated": "Avaliação por IA disponível",
        "show_results": "Mostrar resultados",
        "automatically": "automaticamente",
        "manually": "manualmente"
      },
      "parameters": {
        "title": "Parâmetros",
        "subtitle": "Parâmetros dos participantes",
        "field_title": "Título",
        "team_a": "Equipe A",
        "team_b": "Equipe B",
        "player_a": "Participante A",
        "player_b": "Participante B",
        "points": "Pontos",
        "ratio": "Proporção",
        "add": "Adicionar parâmetro"
      },
      "questions": {
        "title": "Perguntas",
        "subtitle": "Perguntas para os participantes",
        "question": "Pergunta",
        "team": "Equipe",
        "team_placeholder": "Selecione a equipe",
        "answers": "Respostas",
        "points": "Pontos",
        "select_answers": "Selecionar respostas",
        "add_combination": "Adicionar combinação",
        "add_question": "Adicionar pergunta"
      },
      "next": "Próximo",
      "previous": "Anterior",
      "save": "Salvar"
    },
    "saved": "Cenário salvo",
    "to_list": "Voltar à lista",
    "add_detail": "Adicionar cenário",
    "edit_detail": "Editar cenário"
  },
  "notifications": {
    "title": "Notificações",
    "mark_unread": "Marcar tudo como não lido",
    "mark_read": "Marcar tudo como lido",
    "delete_all": "Excluir tudo",
    "no_new": "Nenhuma notificação encontrada",
    "system": "Sistema",
    "evaluation": {
      "ready": {
        "subject": "Avaliação da sessão nº:gameNumber",
        "text": "A sessão foi avaliada por um especialista"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Uma sessão foi atribuída a você",
        "role": "Função:"
      },
      "proposal": {
        "subject": "Coordenação do horário da sessão",
        "time": "Horário:",
        "description": "Confirme ou proponha sua própria opção"
      },
      "agreed": {
        "subject": "Horário da sessão acordado",
        "time": "Horário:",
        "description": "A descrição e as opções de preparação estarão disponíveis :preparationTime minutos antes do início",
        "description_zero": "Você já pode revisar a descrição do cenário e se preparar"
      },
      "preparation": {
        "subject": "Preparação para a sessão",
        "text": "A preparação para a sessão está disponível."
      },
      "started": {
        "subject": "A sessão nº:gameNumber começou",
        "text": "Participe!"
      },
      "missed": {
        "subject": "A sessão nº:gameNumber foi perdida",
        "text": "Você perdeu a sessão"
      },
      "completed": {
        "subject": "A sessão nº:gameNumber foi concluída",
        "text": "Sessão concluída com sucesso"
      },
      "failed": {
        "subject": "A sessão nº:gameNumber falhou",
        "text": "Concluído sem sucesso"
      },
      "results": {
        "proposed": {
          "subject": "Protocolo da sessão nº:gameNumber acordado",
          "text": "Acordo disponível"
        },
        "declined": {
          "subject": "Protocolo da sessão nº:gameNumber rejeitado",
          "text": "Proposta rejeitada"
        },
        "not_agreed": {
          "subject": "Sessão #:gameNumber: as partes não chegaram a um acordo",
          "text": "O capitão adversário indicou que as partes não chegaram a um acordo. A sessão terminou sem sucesso e os resultados não foram contabilizados."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Reunião da sessão nº:gameNumber concluída",
          "text": "Aguarde os resultados."
        },
        "ended-captain": {
          "subject": "Reunião da sessão nº:gameNumber concluída",
          "text_fill": "Preencha o protocolo, por favor.",
          "text_wait": "Aguarde a conclusão do protocolo.",
          "protocol_time": "Tempo do protocolo (minutos): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "Permitido JPG, GIF ou PNG. Tamanho máximo de 2MB",
    "avatar_label_choose": "Escolha",
    "avatar_label_your_avatar": "seu avatar",
    "name": "Nome",
    "last_name": "Sobrenome",
    "patronymic": "Nome do meio",
    "phone": "Telefone",
    "timezone": "Fuso horário",
    "language": "Idioma",
    "country": "País",
    "invalid_phone": "Número de telefone incorreto",
    "save_changes": "Salvar alterações",
    "account": "Conta",
    "security": "Segurança",
    "statistics": "Estatísticas",
    "notifications": "Notificações",
    "change_password_title": "Alterar senha",
    "change_password": "Alterar senha",
    "current_password": "Senha atual",
    "new_password": "Nova senha",
    "confirm_new_password": "Confirmar nova senha",
    "password_requirements": "Requisitos de senha:",
    "password_requirements_1": "Pelo menos 8 caracteres – quanto mais, melhor",
    "password_requirements_2": "Pelo menos um caractere minúsculo",
    "password_requirements_3": "Pelo menos um número, símbolo ou espaço em branco",
    "two_factor_title": "Autenticação de dois fatores",
    "two_factor_description": "Adicione uma camada extra de segurança à sua conta",
    "two_factor_org_enforced": "A autenticação de dois fatores é obrigatória pela sua organização",
    "two_factor_method": "Método de autenticação",
    "two_factor_disabled": "Desativada",
    "two_factor_email": "E-mail",
    "two_factor_sms": "SMS",
    "two_factor_save": "Salvar configurações 2FA"
  },
  "auth": {
    "password": "Senha",
    "new_password": "Nova senha",
    "remember": "Lembrar de mim",
    "timezone": "Fuso horário",
    "forgot": "Esqueceu a senha",
    "login": "Entrar",
    "login_title": "Login",
    "new_password_title": "Alterar senha",
    "change_password": "Salvar",
    "country": "País",
    "invalid_phone": "Número de telefone incorreto",
    "privacy_policy_title": "Política de privacidade",
    "privacy_policy_text": "Texto da política de privacidade...",
    "first_time": "Novo na nossa plataforma?",
    "registration": "Criar uma conta",
    "forgot_title": "Esqueceu a senha?",
    "forgot_description": "Insira seu e-mail e enviaremos instruções para redefinir sua senha",
    "send_reset_link": "Enviar link de redefinição",
    "back_to_login": "Voltar para login",
    "register": "Registrar",
    "name": "Nome",
    "last_name": "Sobrenome",
    "patronymic": "Nome do meio",
    "phone": "Telefone",
    "enter_password": "Digite a senha",
    "confirm_password": "Confirmar senha",
    "not_first_time": "Já tem uma conta?",
    "agree_too": "Eu concordo com",
    "privacy_policy": "política de privacidade e termos",
    "accept": " Eu aceito ",
    "password_validation": "O campo deve conter pelo menos uma maiúscula, minúscula, caractere especial e dígito, com no mínimo 8 caracteres",
    "password_confirm_error": "A confirmação do campo Confirmar senha não corresponde",
    "set_password": "Definir nova senha",
    "reset_password": "Redefinir senha",
    "for": "para",
    "sign_in_to_for": "Entrar no {app} para {org}",
    "registration_title": "Registro",
    "verify_title": "Confirmação de e-mail",
    "verify_head": "Verifique seu e-mail",
    "verify_description": "O link de ativação da conta foi enviado para o seu e-mail. Siga o link para continuar.",
    "verify_new_link": "Um novo link de verificação foi enviado para o e-mail fornecido durante o registro.",
    "verify_send": "Reenviar e-mail de verificação",
    "verify_spam": "Você fez muitas solicitações. Tente novamente em um minuto",
    "verify_logout": "Sair",
    "two_factor_title": "Autenticação de dois fatores",
    "two_factor_description_email": "Enviamos um código de verificação para seu endereço de e-mail. Por favor, insira o código abaixo.",
    "two_factor_description_sms": "Enviamos um código de verificação para seu número de telefone. Por favor, insira o código abaixo.",
    "two_factor_code_label": "Código de verificação",
    "two_factor_code_placeholder": "Digite o código de 6 dígitos",
    "two_factor_verify": "Verificar",
    "two_factor_resend": "Reenviar código",
    "two_factor_resend_success": "Um novo código foi enviado",
    "two_factor_back": "Voltar para login"
  },
  "filepond": {
    "upload": "Enviar",
    "upload_complete": "Envio concluído",
    "uploading": "Enviando",
    "loading": "Carregando",
    "tap_to_cancel": "toque para cancelar",
    "tap_to_undo": "toque para desfazer",
    "upload_aborted": "Envio cancelado",
    "file_too_large": "O arquivo é muito grande"
  },
  "text-editor": {
    "image": "Basta arrastar e soltar sua imagem no editor"
  },
  "webrtc": {
    "ready_to_start": "Pronto para começar",
    "connected": "Conectado – fale agora!",
    "connection_lost": "Conexão perdida. Tente novamente."
  },
  "device_settings": {
    "title": "Configurações de áudio e vídeo",
    "speaker": "Alto-falante/Saída de áudio",
    "refresh_devices": "Atualizar dispositivos",
    "speaker_switch_unsupported": "A troca de alto-falante não é suportada neste navegador"
  },
  "device_setup": {
    "mic_level": "Nível do microfone",
    "mic_on": "Lig",
    "mic_off": "Desl",
    "cam_on": "Lig",
    "cam_off": "Desl"
  },
  "device_test": {
    "title": "Testar Dispositivos de Áudio",
    "speaker_test": "Teste de Alto-falante",
    "speaker_hint": "Clique no botão para reproduzir sons de teste pelo alto-falante selecionado",
    "play_sound": "Reproduzir Som",
    "playing": "Reproduzindo...",
    "speaker_success": "Som Reproduzido ✓",
    "mic_test": "Teste de Microfone",
    "mic_hint": "Clique no botão e fale no microfone para verificar se está funcionando",
    "volume_level": "Nível de Volume",
    "speak_now": "Fale agora...",
    "seconds_short": "s",
    "start_mic_test": "Testar Microfone",
    "testing": "Testando...",
    "test_again": "Testar Novamente",
    "mic_success": "O microfone está funcionando corretamente!",
    "mic_fail": "Problema no microfone detectado",
    "mic_fail_hint": "Nenhum som foi detectado. Verifique se o microfone está conectado, não está mudo e está selecionado corretamente nas configurações."
  },
  "ai_assistant_types": {
    "type": "Tipo",
    "negotiation": "Negociação",
    "feedback": "Feedback",
    "ai_profile": "Sessão com IA"
  },
  "Login": "Login",
  "UI Elements": "Elementos de UI",
  "Forms & Tables": "Formulários e Tabelas",
  "Welcome": "Bem-vindo",
  "Pages": "Páginas",
  "Charts & Maps": "Gráficos e Mapas",
  "Others": "Outros",
  "Typography": "Tipografia",
  "Cards": "Cards",
  "Basic": "Básico",
  "Advance": "Avançado",
  "Widgets": "Widgets",
  "Components": "Componentes",
  "Alert": "Alerta",
  "Close Alert": "Fechar alerta",
  "Avatar": "Avatar",
  "Badge": "Distintivo",
  "Button": "Botão",
  "Calendar": "Calendário",
  "Image": "Imagem",
  "Pagination": "Paginação",
  "Progress Circular": "Progresso circular",
  "Progress Linear": "Progresso linear",
  "Autocomplete": "Autocompletar",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Seletor de data e hora",
  "Select": "Selecionar",
  "Switch": "Interruptor",
  "Checkbox": "Checkbox",
  "Radio": "Rádio",
  "Textarea": "Área de texto",
  "Rating": "Avaliação",
  "File Input": "Entrada de arquivo",
  "Otp Input": "Entrada de OTP",
  "Form Layout": "Layout de formulário",
  "Form Validation": "Validação de formulário",
  "Charts": "Gráficos",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chart.js",
  "Account Settings": "Configurações da conta",
  "User Profile": "Perfil do usuário",
  "FAQ": "FAQ",
  "Dialog Examples": "Exemplos de diálogo",
  "Pricing": "Preços",
  "List": "Lista",
  "Edit": "Editar",
  "Nav Levels": "Níveis de navegação",
  "Level 2.1": "Nível 2.1",
  "Level 2.2": "Nível 2.2",
  "Level 3.1": "Nível 3.1",
  "Level 3.2": "Nível 3.2",
  "Raise Support": "Abrir suporte",
  "Documentation": "Documentação",
  "Dashboards": "Dashboards",
  "Analytics": "Análises",
  "Apps & Pages": "Apps e Páginas",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Fatura",
  "Preview": "Pré-visualizar",
  "Add": "Adicionar",
  "User": "Usuário",
  "View": "Ver",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Register v1": "Registrar v1",
  "Register v2": "Registrar v2",
  "Register": "Registrar",
  "Forget Password v1": "Esqueceu a senha v1",
  "Forget Password v2": "Esqueceu a senha v2",
  "Forgot Password v1": "Esqueceu a senha v1",
  "Forgot Password v2": "Esqueceu a senha v2",
  "Forgot Password": "Esqueceu a senha",
  "Reset Password v1": "Redefinir senha v1",
  "Reset Password v2": "Redefinir senha v2",
  "Reset Password": "Redefinir senha",
  "Miscellaneous": "Diversos",
  "Coming Soon": "Em breve",
  "Not Authorized": "Não autorizado",
  "Under Maintenance": "Em manutenção",
  "Error": "Erro",
  "Statistics": "Estatísticas",
  "Actions": "Ações",
  "Access Control": "Controle de acesso",
  "User Interface": "Interface do usuário",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Ícones",
  "Chip": "Chip",
  "Dialog": "Diálogo",
  "Expansion Panel": "Painel expansível",
  "Combobox": "Combobox",
  "Textfield": "Campo de texto",
  "Range Slider": "Controle deslizante de intervalo",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Abas",
  "Form Elements": "Elementos de formulário",
  "Form Layouts": "Layouts de formulário",
  "Authentication": "Autenticação",
  "Page Not Found - 404": "Página não encontrada - 404",
  "Not Authorized - 401": "Não autorizado - 401",
  "Server Error - 500": "Erro de servidor - 500",
  "2": "2",
  "Forms": "Formulários",
  "Timeline": "Linha do tempo",
  "Disabled Menu": "Menu desativado",
  "Help Center": "Central de ajuda",
  "Verify Email": "Verificar e-mail",
  "Verify Email v1": "Verificar e-mail v1",
  "Verify Email v2": "Verificar e-mail v2",
  "Two Steps": "Duas etapas",
  "Two Steps v1": "Duas etapas v1",
  "Two Steps v2": "Duas etapas v2",
  "Custom Input": "Entrada personalizada",
  "Extensions": "Extensões",
  "Tour": "Tour",
  "Register Multi-Steps": "Registro em múltiplas etapas",
  "Wizard Examples": "Exemplos de assistente",
  "Checkout": "Checkout",
  "Create Deal": "Criar negócio",
  "Property Listing": "Lista de propriedades",
  "Roles & Permissions": "Funções e permissões",
  "Roles": "Funções",
  "Simple Table": "Tabela simples",
  "Tables": "Tabelas",
  "Data Table": "Tabela de dados",
  "Permissions": "Permissões",
  "Apps": "Apps",
  "Misc": "Diversos",
  "Wizard Pages": "Páginas de assistente",
  "Form Wizard": "Assistente de formulário",
  "Numbered": "Numerado",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editores",
  "Front Pages": "Páginas públicas",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Pagamento",
  "Swiper": "Swiper",
  "Product": "Produto",
  "Category": "Categoria",
  "Order": "Pedido",
  "Details": "Detalhes",
  "Customer": "Cliente",
  "Manage Review": "Gerenciar avaliações",
  "Referrals": "Indicações",
  "Settings": "Configurações",
  "Overview": "Visão geral",
  "My Course": "Meu curso",
  "Course Details": "Detalhes do curso",
  "Academy": "Academia",
  "Logistics": "Logística",
  "Dashboard": "Dashboard",
  "Fleet": "Frota",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Manutenção",
  "maintenance-page": {
    "title": "Configurações de manutenção",
    "notification_section": "Notificação global",
    "notification_placeholder": "Digite a mensagem de notificação para todos os usuários",
    "notification_hint": "Esta mensagem será exibida para todos os usuários autenticados como aviso",
    "games_section": "Bloqueio de sessões",
    "games_blocked_label": "Bloquear novas sessões",
    "games_blocked_hint": "Quando ativado, os usuários não podem criar ou iniciar novas sessões. Sessões existentes ainda podem ser acessadas.",
    "save": "Salvar",
    "clear": "Limpar",
    "clear_confirm": "Tem certeza de que deseja limpar a notificação?",
    "last_updated": "Última atualização",
    "updated_by": "por",
    "games_blocked_message": "Pedimos desculpas pelo inconveniente. A plataforma está atualmente em manutenção. As sessões estão temporariamente indisponíveis."
  },
  "$vuetify": {
    "badge": "Distintivo",
    "noDataText": "Nenhum dado disponível",
    "close": "Fechar",
    "open": "abrir",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimitador"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Itens por página:",
      "itemsPerPageAll": "Todos",
      "pageText": "{0}-{1} de {2}",
      "firstPage": "Primeira página",
      "prevPage": "Página anterior",
      "nextPage": "Próxima página",
      "lastPage": "Última página"
    },
    "pagination": {
      "ariaLabel": {
        "root": "raiz",
        "previous": "anterior",
        "next": "próxima",
        "first": "primeira",
        "last": "última",
        "currentPage": "página atual",
        "page": "página"
      }
    },
    "input": {
      "clear": "limpar",
      "appendAction": "ação de anexar",
      "prependAction": "ação de prefixo",
      "counterSize": "tamanho do contador",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "tamanho do contador"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Relatório de Desenvolvimento de Habilidades",
    "generate": "Gerar",
    "generate_description": "Gerar um relatório completo de desenvolvimento de habilidades para um período selecionado",
    "manager_description": "Gerar relatórios de desenvolvimento de habilidades para os funcionários da sua organização",
    "date": "Data",
    "competence": "Competência",
    "period": "Período",
    "status_label": "Status",
    "actions": "Ações",
    "employee": "Funcionário",
    "view": "Ver relatório",
    "download_pdf": "Baixar PDF",
    "no_reports": "Nenhum relatório gerado ainda",
    "data_not_available": "Os dados do relatório ainda não estão disponíveis",
    "generation_failed": "Falha na geração do relatório",
    "retry": "Tentar novamente",
    "rate_limit_exceeded": "Limite de geração de relatórios atingido. Por favor, tente novamente mais tarde.",
    "too_many_pending": "Você tem muitos relatórios em andamento. Por favor, aguarde a conclusão deles.",
    "no_games_for_report": "Nenhuma sessão concluída encontrada para o período e a competência selecionados. O relatório não pode ser gerado.",
    "report_already_exists": "Já existe um relatório com esses parâmetros. Verifique a lista abaixo.",
    "period_too_long": "O período do relatório não deve exceder um ano.",
    "invalid_parameters": "Verifique a competência e o período",
    "filter_by_employee": "Filtrar por funcionário...",
    "batch": {
      "mode_single": "Relatório único",
      "mode_batch": "Lote",
      "load_employees": "Mostrar funcionários",
      "sessions": "Sessões",
      "no_candidates": "Nenhum funcionário com sessões concluídas para a competência e o período selecionados",
      "generate_selected": "Gerar ({count})",
      "selected_limit": "É possível selecionar no máximo {max} funcionários por vez",
      "progress": "{ready} de {total} prontos",
      "failed_count": "Falhas: {count}",
      "status_unknown": "Status desconhecido",
      "status_unknown_hint": "O relatório não foi encontrado na lista — confira a tabela de relatórios abaixo",
      "reused": "Relatórios reaproveitados: {count} — gerados nas últimas {hours} h e não criados novamente",
      "reused_badge": "Reaproveitado",
      "reused_on": "Gerado em {date}",
      "download_all": "Baixar tudo",
      "toggle_details": "Mostrar o conteúdo do lote",
      "dismiss_confirm": "Este lote ainda está sendo gerado. Removê-lo da tela? O progresso e o botão “Baixar tudo” serão perdidos; os relatórios permanecem na lista abaixo.",
      "archive_unavailable": "Não foi possível montar o arquivo: alguns relatórios ainda não estão prontos ou não estão mais disponíveis",
      "archive_failed": "Não foi possível baixar o arquivo",
      "archive_building": "Montando o arquivo…",
      "archive_build_failed": "Não foi possível montar o arquivo. Tente novamente.",
      "candidates_failed": "Não foi possível carregar a lista de funcionários",
      "stale_selection": "Alguns funcionários selecionados não estão mais disponíveis. A lista foi atualizada — selecione novamente."
    },
    "quota": {
      "remaining_hour": "Limite de relatórios: {limit} por hora. Você pode solicitar mais {remaining} agora. Selecione menos funcionários ou tente novamente às {time}.",
      "remaining_day": "Limite de relatórios: {limit} por dia. Você pode solicitar mais {remaining} agora. Selecione menos funcionários ou tente novamente às {time}.",
      "exhausted_hour": "Limite de relatórios ({limit} por hora) atingido. Ele será redefinido às {time}.",
      "exhausted_day": "Limite de relatórios ({limit} por dia) atingido. Ele será redefinido às {time}.",
      "too_large_hour": "Limite de relatórios: {limit} por hora. Selecione menos funcionários.",
      "too_large_day": "Limite de relatórios: {limit} por dia. Selecione menos funcionários."
    },
    "status": {
      "pending": "Pendente",
      "collecting_data": "Coletando dados...",
      "analyzing": "Análise de IA...",
      "generating_pdf": "Gerando PDF...",
      "ready": "Pronto",
      "failed": "Falhou"
    },
    "report": {
      "kicker": "Relatório de desenvolvimento de competência",
      "position": "Cargo",
      "department": "Departamento",
      "period": "Período",
      "games_count": "Sessões realizadas",
      "not_specified_f": "Não especificada",
      "not_specified_n": "Não especificado",
      "fig": {
        "your_average": "Sua pontuação média",
        "company_average": "Média da empresa",
        "participants": "Participantes no período",
        "skills_count": "Habilidades avaliadas"
      },
      "sec": {
        "profile": "Perfil da Competência",
        "trend": "Evolução por Sessão",
        "strengths": "No Que se Apoiar",
        "priorities": "Três Prioridades de Desenvolvimento",
        "skills": "Análise por Habilidade",
        "plan": "Plano de Três Meses"
      },
      "legend": {
        "you": "Sua pontuação",
        "company": "Média da empresa"
      },
      "dotplot_caption": "Desvio em relação à média — da maior vantagem à maior defasagem",
      "trend_disclaimer": "As pontuações das sessões não são diretamente comparáveis: a dificuldade dos casos varia de uma sessão para outra. Uma queda não significa, por si só, que a habilidade tenha regredido — o gráfico é uma observação, não um veredicto.",
      "no_comparison": "A comparação com a média da empresa não está disponível: no período, menos de três pessoas realizaram sessões desta competência. O relatório se baseia em pontuações absolutas.",
      "skill": {
        "works": "O que funciona",
        "blocks": "O que atrapalha",
        "actions": "O que fazer",
        "out_of_ten": "de 10",
        "company_short": "empresa"
      },
      "level": {
        "outstanding": "Resultado excepcional",
        "strength": "Ponto forte",
        "meets_standard": "No nível da empresa",
        "needs_attention": "Requer atenção",
        "needs_development": "Área de desenvolvimento"
      },
      "plan": {
        "month": "Mês",
        "goals": "Metas",
        "actions": "Ações"
      },
      "colophon": {
        "built_on": "O relatório se baseia nas sessões do período {from} — {to}. Total de sessões: {count}.",
        "comparison": "A comparação é com a média da empresa no mesmo período. Participantes: {count}."
      }
    }
  },
  "api-tokens": "API Tokens",
  "api-tokens-page": {
        "select_user": "Usuário",
        "select_user_hint": "Selecione um usuário para visualizar e gerenciar seus tokens de API.",
        "no_users_found": "Nenhum usuário encontrado",
        "no_tokens": "Este usuário não possui tokens de API.",
        "token_name": "Nome",
        "abilities": "Permissões",
        "ability": "Permissão",
        "created_at": "Criado em",
        "last_used_at": "Último uso em",
        "expires_at": "Expira em",
        "actions": " ",
        "issue_token": "Emitir Token",
        "issue": "Emitir",
        "issue_failed": "Falha ao emitir o token",
        "token": "Token",
        "plaintext_warning": "Copie este token agora — ele não será exibido novamente.",
        "revoke": "Revogar",
        "revoke_confirm": "Tem certeza de que deseja revogar este token? As integrações que o utilizam deixarão de funcionar."
    },
  "subscription": {
    "current_plan": "Plano Atual",
    "expires_at": "Expira em: {date}",
    "no_active_plan": "Nenhum plano de assinatura ativo",
    "quota_warning": "Cota disponível baixa",
    "regular_games": "Sessões Regulares",
    "ai_games": "Sessões de IA",
    "any_games": "Quaisquer sessões",
    "used_of": "{used} de {limit}",
    "remaining": "{count} restantes",
    "quota_exceeded": "Cota de funcionalidade excedida",
    "tickets_only": "Pacotes de Créditos",
    "session_package": "Pacote de sessões",
    "games_available": "Sessões",
    "users": "Usuários",
    "active_users": "Usuários Ativos",
    "active_tickets": "Pacotes de Créditos",
    "ticket_charges": "{charges} créditos",
    "ticket_no_expiry": "Sem expiração",
    "unlimited": "Ilimitado",
    "no_game_limits": "Sem restrições no número de sessões"
  },
  "knowledge-base-page": {
    "provider-unsupported": "A base de conhecimento não está disponível com o provedor de IA atual da sua organização."
  },
  "candidate-page": {
    "document_title": "Entrevista",
    "greeting": "Olá, {name}!",
    "intro_lead": "A {organization} convida você para uma entrevista com um entrevistador virtual para a vaga «{vacancy}».",
    "duration": "A entrevista dura cerca de {minutes} min.",
    "requirements_title": "O que você vai precisar",
    "requirement_mic": "Um microfone funcionando, de preferência um headset",
    "requirement_camera_required": "Câmera ligada: ela é obrigatória para esta entrevista",
    "requirement_camera_optional": "A câmera é opcional, mas com ela a conversa fica mais natural",
    "requirement_browser": "Um computador com Chrome, Edge ou Safari atualizados",
    "requirement_network": "Conexão estável e um lugar tranquilo, sem interrupções",
    "continue": "Continuar",
    "consent": {
      "accept": "Li o texto e autorizo o tratamento dos meus dados pessoais",
      "back": "Voltar",
      "start": "Iniciar a entrevista"
    },
    "terminal": {
      "finished": {
        "title": "Obrigado!",
        "text": "A entrevista foi concluída e o resultado foi enviado ao recrutador — ele entrará em contato com você. Você já pode fechar esta página."
      },
      "already_completed": {
        "title": "Entrevista já concluída",
        "text": "Esta entrevista já foi concluída por este link. Se precisar refazê-la, entre em contato com o recrutador."
      },
      "not_found": {
        "title": "Link não encontrado",
        "text": "O endereço pode conter um erro de digitação, ou o link não é mais válido. Verifique o e-mail do recrutador ou entre em contato com ele."
      },
      "session_conflict": {
        "title": "Você está conectado(a) a outra conta",
        "text": "Saia da conta atual ou abra o link em uma janela anônima do navegador."
      },
      "link_revoked": {
        "title": "O acesso a este link foi encerrado",
        "text": "O recrutador revogou este link. Entre em contato com ele para receber um novo."
      },
      "link_expired": {
        "title": "O link expirou",
        "text": "Entre em contato com o recrutador para que ele emita um novo link."
      },
      "attempts_exhausted": {
        "title": "Não há mais tentativas",
        "text": "Todas as tentativas disponíveis para este link já foram usadas. Entre em contato com o recrutador."
      },
      "unavailable": {
        "title": "Não é possível iniciar agora",
        "text": "Tente novamente mais tarde ou entre em contato com o recrutador."
      },
      "rate_limited": {
        "title": "Muitas tentativas",
        "text": "Aguarde um minuto e atualize a página."
      },
      "aborted": {
        "title": "A entrevista não foi iniciada",
        "text": "Atualize a página e tente novamente. Se não ajudar, entre em contato com o recrutador."
      },
      "generic": {
        "title": "Algo deu errado",
        "text": "Atualize a página e tente novamente. Se não ajudar, entre em contato com o recrutador."
      }
    }
  },
  "recruiting-page": {
    "title": "Recrutamento",
    "create": "Nova vaga",
    "edit": "Editar vaga",
    "empty": "Ainda não há vagas",
    "load_error": "Não foi possível carregar a lista de vagas",
    "retry": "Tentar novamente",
    "back": "Voltar à lista de vagas",
    "open": "Candidatos",
    "archive": "Arquivar",
    "no_expiry": "Sem prazo",
    "confirm_archive": "Arquivar esta vaga? Não será mais possível emitir novos links para ela.",
    "headers": {
      "title": "Vaga",
      "scenario": "Cenário",
      "status": "Status",
      "expires_at": "Válido até",
      "actions": "Ações"
    },
    "status": {
      "draft": "Rascunho",
      "active": "Ativa",
      "archived": "Arquivada"
    },
    "dialog": {
      "title_label": "Título da vaga",
      "scenario_label": "Cenário da entrevista",
      "scenario_placeholder": "Selecione um cenário para a sessão com IA",
      "scenario_hint": "São exibidos apenas os cenários compatíveis com sessão com IA",
      "status_label": "Status",
      "expires_label": "Válido até",
      "expires_hint": "Deixe em branco para vaga sem prazo",
      "save": "Salvar",
      "cancel": "Cancelar"
    },
    "messages": {
      "created": "Vaga criada",
      "updated": "Vaga atualizada",
      "archived": "Vaga arquivada",
      "revoked": "Link revogado",
      "attempt_granted": "Mais uma tentativa concedida ao candidato",
      "copied": "Link copiado",
      "error": "Algo deu errado"
    },
    "candidates": {
      "title": "Candidatos",
      "empty": "Ainda não foi emitido nenhum link para esta vaga",
      "load_error": "Não foi possível carregar a lista de candidatos",
      "issue": "Emitir link",
      "import": "Importar de um arquivo",
      "expired": "Expirado",
      "no_games": "Entrevista não iniciada",
      "attempts": "{used} de {allowed}",
      "revoke": "Revogar link",
      "extra_attempt": "Conceder mais uma tentativa",
      "open_result": "Abrir resultado da entrevista",
      "confirm_revoke": "Revogar o link deste candidato? O acesso será perdido imediatamente, inclusive a uma entrevista em andamento.",
      "confirm_extra_attempt": "Conceder mais uma tentativa a este candidato?",
      "headers": {
        "candidate": "Candidato",
        "link_status": "Link",
        "invite": "Convite",
        "game_status": "Entrevista",
        "attempts": "Tentativas",
        "expires_at": "Link válido até",
        "actions": "Ações"
      },
      "link_status": {
        "created": "Emitido",
        "opened": "Aberto",
        "in_progress": "Entrevista em andamento",
        "completed": "Entrevista concluída",
        "revoked": "Revogado"
      },
      "invite_status": {
        "not_sent": "Não enviado",
        "queued": "Na fila",
        "sent": "Enviado",
        "failed": "Falha no envio"
      },
      "invite_sent_at": "O serviço de email aceitou a mensagem em {date}",
      "invite_failure": {
        "rejected": "O serviço de email rejeitou a mensagem — envie o link ao candidato por conta própria",
        "transport": "Falha no envio — envie o link ao candidato por conta própria",
        "revoked": "O link foi revogado",
        "sending_disabled": "O envio de emails está desativado",
        "blocked": "O endereço está na lista de bloqueio — envie o link ao candidato por conta própria"
      }
    },
    "issue_dialog": {
      "title": "Emitir link pessoal",
      "name": "Nome",
      "last_name": "Sobrenome",
      "email": "Email",
      "phone": "Telefone",
      "attempts": "Tentativas permitidas",
      "expires_at": "Link válido até",
      "expires_hint": "Deixe em branco para usar o prazo da vaga",
      "submit": "Emitir link",
      "close": "Fechar",
      "result_title": "Link emitido",
      "warning": "Copie o link agora — ele é exibido apenas uma vez. No banco de dados fica armazenado só o seu hash, então não é possível recuperar o link: um link perdido precisa ser revogado e emitido novamente.",
      "copy": "Copiar",
      "copied": "Copiado",
      "send_invite": "Enviar convite para {email}",
      "send_invite_no_email": "Enviar convite por email",
      "send_invite_blocked": "Este endereço está na lista de bloqueio — o email não será enviado",
      "invite_queued": "Convite colocado na fila para {email}",
      "invite_blocked": "Convite não enviado: {email} está na lista de bloqueio. Envie o link ao candidato por conta própria"
    },
    "import_dialog": {
      "title": "Importar candidatos",
      "subtitle": "Cada linha do arquivo gera um candidato e um link pessoal.",
      "file": "Arquivo com a lista de candidatos",
      "columns": "Colunas: Nome, Sobrenome, Email, Telefone",
      "limits": "xlsx ou CSV com «;», até 200 linhas e 10 MB",
      "size_error": "O arquivo é maior que 10 MB",
      "download_example": "Baixar exemplo",
      "note_title": "Os links ficam visíveis apenas no arquivo baixado",
      "note_text": "O arquivo é baixado assim que o import termina. No banco de dados fica armazenado apenas o hash dos links — não é possível exportá-los uma segunda vez, guarde o arquivo.",
      "submit": "Iniciar importação",
      "cancel": "Cancelar",
      "result_title": "Links emitidos",
      "result": "Links emitidos: {count}. O arquivo foi baixado.",
      "invites_blocked": "Convites não enviados: {count}. Estes endereços estão na lista de bloqueio — envie os links a esses candidatos por conta própria.",
      "saved_title": "Guarde o arquivo baixado",
      "saved_text": "Esta é a única cópia desses links: no banco de dados fica armazenado apenas o hash deles. Um link perdido só pode ser revogado e emitido novamente.",
      "download_again": "Baixar o arquivo novamente",
      "errors_title": "Linhas rejeitadas",
      "error_row": "Linha {row}: {error}",
      "errors_truncated": "…e mais {count} linhas rejeitadas. As primeiras 50 estão listadas acima.",
      "send_invites": "Enviar convites por email aos candidatos",
      "send_invites_hint": "Candidatos sem endereço de email não receberão o convite"
    }
  },
  "ai-reports": "Relatórios de IA",
  "ai-reports-page": {
    "title": "Relatórios de IA",
    "subtitle": "Descreva o relatório com suas próprias palavras — montamos a especificação, mostramos uma prévia e exportamos para Excel.",
    "status": {
      "draft": "Rascunho",
      "pending": "Gerando",
      "ready": "Pronto",
      "failed": "Falhou"
    },
    "list": {
      "title": "Meus relatórios",
      "new": "Novo relatório",
      "empty": "Ainda não há relatórios. Clique em “Novo relatório” e descreva o que você precisa.",
      "untitled": "Sem título",
      "delete": "Excluir relatório",
      "delete_confirm": "Excluir o relatório junto com o arquivo gerado?",
      "deleted": "Relatório excluído"
    },
    "dialog": {
      "title": "Diálogo",
      "open_dictionary": "Dicionário de dados",
      "placeholder": "Por exemplo: quantas partidas cada departamento realizou no último trimestre",
      "send": "Enviar",
      "empty_title": "O que o relatório deve mostrar?",
      "empty_text": "Escreva com palavras simples: quais dados, para qual período e em qual detalhamento. Se faltar algo, eu pergunto.",
      "examples_title": "Por exemplo:",
      "examples": {
        "e1": "Quantas partidas cada departamento realizou no último trimestre",
        "e2": "Pontuação média de competências no departamento de vendas em 2026",
        "e3": "Funcionários que não jogam há mais de um mês",
        "e4": "Candidatos por vaga e status dos links nos últimos 30 dias"
      },
      "thinking": "Gerando o relatório…",
      "waiting_hint": "A resposta aparecerá aqui sozinha — não é preciso atualizar a página.",
      "retry": "Tentar novamente",
      "dismiss": "Ocultar",
      "spec_ready": "O relatório está pronto — confira a prévia abaixo e gere o arquivo.",
      "stuck_title": "Parece que estamos girando em círculos",
      "stuck_text": "Consulte o dicionário de dados e reformule o pedido usando os termos dele — é mais rápido do que responder mais uma pergunta de esclarecimento.",
      "rejected_title": "Esse relatório ainda não pode ser gerado",
      "reason": {
        "no_such_measure": "Essa medida não existe em nossos dados. Consulte a lista de medidas no dicionário.",
        "no_such_field": "Esse campo não existe em nossos dados. Consulte a lista de campos no dicionário.",
        "cross_dataset": "O pedido exige dados de dois conjuntos de dados ao mesmo tempo. Divida-o em dois relatórios.",
        "window_function": "Percentuais do total, posições em ranking e comparação com o período anterior ainda não são suportados.",
        "other": "O pedido vai além dos dados disponíveis. Consulte o dicionário e tente outra formulação."
      },
      "usage": {
        "employees": "nenhum funcionário | {n} funcionário | {n} funcionários",
        "games": "nenhuma partida | {n} partida | {n} partidas",
        "scenarios": "nenhum cenário | {n} cenário | {n} cenários",
        "evaluations": "nenhuma avaliação | {n} avaliação | {n} avaliações",
        "candidates": "nenhum candidato | {n} candidato | {n} candidatos"
      },
      "option_created_at": "adição: {date}"
    },
    "preview": {
      "title": "Prévia",
      "no_report": "Escolha um relatório à esquerda ou comece um novo.",
      "no_spec": "Descreva o relatório no diálogo — a prévia aparece assim que o pedido for compreendido.",
      "spec_title": "O que o relatório vai conter",
      "rows_hint": "Mostrando as primeiras {count} linhas",
      "total": "Total de linhas: {count}",
      "zero_rows": "Esse pedido não retorna nenhuma linha. Amplie o período ou remova filtros — não faz sentido gerar um arquivo vazio.",
      "zero_rows_hint": "Verifique os valores dos filtros — pode não haver dados para eles",
      "duplicate_rows": "Algumas linhas da pré-visualização são idênticas: as colunas escolhidas não distinguem os registros deste conjunto de dados. Verifique o que uma linha realmente significa aqui — pode estar faltando uma coluna que as diferencie.",
      "too_many_rows": "O relatório tem {count} linhas, o máximo é {max}. Restrinja o período ou adicione filtros: ao ultrapassar o limite, o arquivo não é gerado, em vez de truncado.",
      "generate": "Gerar arquivo",
      "regenerate": "Gerar novamente",
      "queued": "O arquivo está sendo gerado — o cartão será atualizado automaticamente quando estiver pronto.",
      "failed": "Não foi possível gerar o relatório",
      "download": "Baixar .xlsx",
      "downloads": "Downloads: {count}",
      "ttl_warning": "O arquivo é mantido por {days} dias e depois é excluído — baixe-o assim que possível.",
      "expires_at": "Disponível até {date}",
      "expired": "O arquivo foi excluído ao final do período de retenção — gere o relatório novamente."
    },
    "spec": {
      "dataset": "Dados",
      "columns": "Colunas",
      "measures": "Medidas",
      "group_by": "Detalhamento",
      "period": "Período",
      "period_value": "{field}: de {from} até {to}",
      "period_all": "Todo o período disponível",
      "filters": "Filtros",
      "having": "Condições sobre as medidas",
      "sort": "Ordenação",
      "limit": "Limite de linhas",
      "limit_value": "primeiras {count} linhas",
      "granularity": {
        "year": "por ano",
        "quarter": "por trimestre",
        "month": "por mês",
        "week": "por semana",
        "day": "por dia",
        "dow": "por dia da semana"
      },
      "dir": {
        "asc": "crescente",
        "desc": "decrescente"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — diferente de {value}",
        "in": "{field} — um de: {value}",
        "not_in": "{field} — exceto: {value}",
        "gt": "{field} maior que {value}",
        "gte": "{field} pelo menos {value}",
        "lt": "{field} menor que {value}",
        "lte": "{field} no máximo {value}",
        "contains": "{field} contém “{value}”",
        "between": "{field} — de {from} até {to}",
        "is_null": "{field} não preenchido",
        "is_not_null": "{field} preenchido"
      }
    },
    "value": {
      "yes": "Sim",
      "no": "Não"
    },
    "dictionary": {
      "title": "Dicionário de dados",
      "subtitle": "Tudo o que pode ser incluído em um relatório. A lista é ao vivo: é a mesma a partir da qual a especificação é construída.",
      "fields": "Campos",
      "measures": "Medidas",
      "values": "Valores",
      "show_values": "Mostrar os valores da sua organização",
      "hide_values": "Ocultar valores",
      "values_error": "Não foi possível carregar os valores — tente novamente.",
      "values_empty": "Sua organização ainda não tem valores para este campo.",
      "limits": {
        "title": "O que um relatório não consegue fazer",
        "pivot": "Uma tabela dinâmica com uma coluna por participante ou por pergunta não será montada. Peça a forma longa em vez disso: uma linha para cada par participante-pergunta.",
        "window": "O relatório não calcula a variação mês a mês, a participação no total, a posição no ranking nem “os três melhores de cada departamento”. Pegue a divisão por mês e termine a conta no Excel.",
        "missing": "O que o sistema não armazena não aparece no relatório: salários, NPS e outros dados guardados em outros sistemas não aparecem sob nenhum nome."
      },
      "empty": "O dicionário está vazio — entre em contato com o administrador.",
      "close": "Fechar"
    },
    "errors": {
      "generic": "Algo deu errado. Tente novamente.",
      "detail": "Não compreendido: {value}",
      "rate_limit": "Muitas solicitações. Aguarde um minuto e tente novamente.",
      "download": "Não foi possível baixar o arquivo.",
      "turn_failed": "Não foi possível obter a resposta. Envie a solicitação novamente.",
      "turn_stuck_in_queue": "A solicitação não chegou a ser processada — ficou tempo demais na fila. Envie-a novamente.",
      "unknown_resolution": "Esta opção está desatualizada — o relatório mudou nesse meio-tempo. Abra-o novamente e detalhe sua solicitação."
    }
  },
    "externalLaunch": {
        "document_title": "Sessão de prática",
        "intro": {
            "title": "Conversa de prática",
            "lead": "Você vai conversar com um interlocutor virtual. A conversa é gravada e avaliada, e o resultado volta para o seu sistema de aprendizagem.",
            "requirements_title": "O que você vai precisar",
            "requirement_mic": "Um microfone funcionando, de preferência um headset",
            "requirement_camera": "A câmera é opcional, mas a conversa fica mais natural com ela",
            "requirement_browser": "Um computador com Chrome, Edge ou Safari atualizados",
            "requirement_network": "Uma conexão estável e um lugar tranquilo onde ninguém vai te interromper",
            "start": "Começar"
        },
        "relaunch_hint": "Volte para o seu sistema de aprendizagem e abra o material novamente.",
        "saving": "Salvando o resultado…",
        "review": {
            "document_title": "Revisão da sessão",
            "attempt": "Tentativa {number}",
            "result": {
                "passed": "Aprovado",
                "failed": "Não aprovado",
                "pending": "Ainda sem avaliação"
            },
            "score_of_100": "{score} de 100",
            "threshold": "Nota de aprovação: {threshold}",
            "skills_title": "Habilidades e recomendações",
            "skills_empty": "Ainda não há feedback detalhado por habilidade para esta tentativa.",
            "comments_title": "Comentários na gravação",
            "comments_empty": "Não há comentários nesta gravação.",
            "loading": "Carregando a revisão",
            "error": {
                "not_found": {
                    "title": "O link não funciona",
                    "text": "A revisão não está mais disponível: o link expirou ou a tentativa foi retirada."
                },
                "expired": {
                    "title": "A página expirou",
                    "text": "Abra a revisão novamente pelo link no seu sistema de aprendizagem."
                },
                "generic": {
                    "title": "Não foi possível mostrar a revisão",
                    "text": "Algo deu errado do nosso lado. Tente abrir o link novamente."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Obrigado!",
                "text": "A conversa terminou. O resultado vai aparecer no seu sistema de aprendizagem assim que a avaliação estiver pronta. Você já pode fechar esta página."
            },
            "aborted": {
                "title": "A conversa não começou",
                "text": "Algo deu errado antes de a conversa começar."
            },
            "token_expired": {
                "title": "A sessão expirou",
                "text": "O acesso a esta conversa não é mais válido."
            },
            "not_found": {
                "title": "O link não funciona",
                "text": "O endereço pode ter um erro de digitação, ou o link não é mais válido."
            },
            "rate_limited": {
                "title": "Muitas tentativas",
                "text": "Espere um minuto antes de tentar novamente."
            },
            "generic": {
                "title": "Não é possível começar agora",
                "text": "Algo deu errado do nosso lado."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "O material está fechado",
                "text": "Este material não está mais disponível para prática."
            },
            "publication_draft": {
                "title": "O material ainda não foi publicado",
                "text": "A prática deste material ainda não foi aberta."
            },
            "publication_expired": {
                "title": "O material expirou",
                "text": "O período em que era possível praticar este material terminou."
            },
            "feature_disabled": {
                "title": "O material está fechado",
                "text": "A prática a partir do sistema de aprendizagem está desativada para a sua organização."
            },
            "connection_disabled": {
                "title": "O material está fechado",
                "text": "A conexão com o seu sistema de aprendizagem está desativada. Fale com a pessoa que atribuiu o curso."
            },
            "launch_limit_reached": {
                "title": "O limite foi atingido",
                "text": "Este material já atingiu o número máximo de conversas."
            },
            "daily_budget_exhausted": {
                "title": "Chega por hoje",
                "text": "Você atingiu o número de conversas permitidas por dia. Tente novamente amanhã."
            },
            "attempts_exhausted": {
                "title": "Não há mais tentativas",
                "text": "Você usou todas as tentativas permitidas para este material."
            },
            "quota_exhausted": {
                "title": "Não é possível começar agora",
                "text": "A sua organização não tem mais conversas disponíveis. Fale com a pessoa que atribuiu o curso."
            },
            "user_limit_reached": {
                "title": "Não é possível começar agora",
                "text": "A sua organização não tem mais vagas disponíveis. Fale com a pessoa que atribuiu o curso."
            },
            "scenario_unavailable": {
                "title": "O material está indisponível",
                "text": "A conversa por trás deste material não existe mais."
            },
            "assignment_check_unavailable": {
                "title": "Não é possível começar agora",
                "text": "Não conseguimos confirmar que este material foi atribuído a você. Fale com a pessoa que atribuiu o curso."
            },
            "code_invalid": {
                "title": "O link não é mais válido",
                "text": "Este link já foi usado ou o tempo dele acabou."
            },
            "channel_verification_failed": {
                "title": "O sistema de aprendizagem não respondeu",
                "text": "Não conseguimos confirmar a solicitação com o seu sistema de aprendizagem."
            },
            "external_system_unavailable": {
                "title": "O sistema de aprendizagem não está respondendo",
                "text": "Não conseguimos verificar a atribuição do seu curso no sistema de aprendizagem. Tente novamente em alguns minutos."
            },
            "user_not_found": {
                "title": "Não conseguimos confirmar a sua identidade",
                "text": "Não existe uma conta para você aqui, e a sua organização não cria contas automaticamente. Fale com a pessoa que atribuiu o curso."
            },
            "user_unavailable": {
                "title": "A sua conta está desativada",
                "text": "Fale com a pessoa que atribuiu o curso."
            },
            "user_deleted": {
                "title": "A sua conta foi excluída",
                "text": "Fale com a pessoa que atribuiu o curso."
            },
            "email_taken_linking_disabled": {
                "title": "Não conseguimos confirmar a sua identidade",
                "text": "O seu endereço de e-mail já pertence a outra conta aqui. Fale com a pessoa que atribuiu o curso."
            },
            "service_role_not_allowed": {
                "title": "Esta conta não pode praticar",
                "text": "Contas de administrador não participam de conversas de prática. Use a sua conta de aluno."
            },
            "unverified_request": {
                "title": "Não conseguimos confirmar a solicitação",
                "text": "O seu sistema de aprendizagem não confirmou que foi você quem iniciou esta conversa."
            }
        },
        "manage": {
            "nav": {
                "group": "Lançamento externo",
                "publications": "Publicações",
                "connections": "Conexões LMS"
            },
            "messages": {
                "error": "Algo deu errado. Tente novamente.",
                "load_error": "Não foi possível carregar os dados."
            },
            "connections": {
                "title": "Conexões LMS",
                "subtitle": "Contas de sistemas de aprendizagem a partir das quais esta organização inicia as práticas.",
                "create": "Adicionar conexão",
                "edit": "Editar",
                "set_credentials": "Definir credenciais",
                "empty": "Ainda não há conexões.",
                "secret_missing": "Não definido",
                "no_expiry": "Não expira",
                "headers": {
                    "account": "Conta",
                    "base_url": "Endereço",
                    "client_id": "ID do cliente",
                    "secret": "Segredo",
                    "status": "Status",
                    "expires_at": "Validade das credenciais",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Sem credenciais",
                    "active": "Ativa",
                    "expired": "Credenciais expiradas",
                    "disabled": "Desativada"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nova conexão",
                    "edit_title": "Conexão",
                    "immutable_hint": "O sistema de aprendizagem e a conta não podem ser alterados: eles definem o espaço de identidade do aluno. Uma conta diferente é uma nova conexão.",
                    "lms_label": "Sistema de aprendizagem",
                    "account_key_label": "Conta",
                    "account_key_hint": "O identificador da conta no sistema de aprendizagem.",
                    "base_url_label": "Endereço REST API do iSpring",
                    "base_url_hint": "Por exemplo, https://api-learn.ispringlearn.ru. Não é o endereço do portal da empresa: é para ele que vai o segredo.",
                    "base_url_https": "O endereço deve começar com https://",
                    "enabled_label": "Conexão ativada",
                    "enabled_hint": "Uma conexão nunca é excluída — ela é desativada. As publicações e os inícios continuam nas listas, mas novos inícios são recusados e os resultados deixam de ir para o sistema de aprendizagem.",
                    "credentials_optional": "As credenciais são opcionais. Sem elas, a conexão funciona em modo limitado.",
                    "client_id_label": "ID do cliente",
                    "secret_label": "Segredo",
                    "secret_hint": "Armazenado de forma criptografada. Nunca pode ser lido de volta — apenas os últimos quatro caracteres são exibidos.",
                    "expires_at_label": "Validade das credenciais",
                    "expires_at_hint": "Deixe em branco se as credenciais não tiverem validade."
                },
                "credentials_dialog": {
                    "title": "Credenciais",
                    "lead": "O novo segredo substitui o anterior. A conexão mantém o seu identificador, e os links dos alunos e os inícios continuam onde estavam.",
                    "secret_hint": "O segredo anterior não é mais necessário e não pode ser lido de volta."
                },
                "messages": {
                    "saved": "Conexão salva",
                    "credentials_saved": "Credenciais salvas"
                }
            },
            "publications": {
                "title": "Publicações",
                "subtitle": "Cenários abertos para início a partir de um sistema de aprendizagem.",
                "create": "Nova publicação",
                "edit": "Editar",
                "enable": "Ativar",
                "disable": "Desativar",
                "open_journal": "Registro",
                "download_package": "Baixar pacote",
                "empty": "Ainda não há publicações.",
                "no_connections": "Ainda não há conexão com um sistema de aprendizagem. Um administrador da plataforma configura isso.",
                "no_expiry": "Sem validade",
                "attempts_unlimited": "Ilimitado",
                "immutable_hint": "A conexão, o cenário e o canal de entrega não podem ser alterados: eles estão embutidos no pacote já enviado ao sistema de aprendizagem. Tudo o mais se aplica sem reconstruí-lo.",
                "headers": {
                    "scenario": "Cenário",
                    "connection": "Conexão",
                    "channel": "Canal",
                    "status": "Status",
                    "settings": "Configurações",
                    "expires_at": "Expira",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Tentativas: {value}",
                    "threshold": "Nota de aprovação: {value}"
                },
                "status": {
                    "draft": "Rascunho",
                    "active": "Ativa",
                    "disabled": "Desativada"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Somente o status",
                    "status_and_score": "Status e nota",
                    "status_score_and_review": "Status, nota e link para a revisão"
                },
                "warnings": {
                    "limited_mode": "Modo limitado: a nota e o resultado não vão aparecer no sistema de aprendizagem, e a verificação de atribuição não é realizada.",
                    "connection_disabled": "A conexão está desativada: os inícios por meio desta publicação não são aceitos de forma alguma até que um administrador a reative.",
                    "assignment_check_off": "Com a opção desativada, uma reatribuição do curso não é detectada.",
                    "no_course_binding": "A publicação não está vinculada a um curso — a nota não vai chegar ao sistema de aprendizagem."
                },
                "dialog": {
                    "connection_label": "Conexão",
                    "scenario_label": "Cenário",
                    "channel_label": "Canal de entrega",
                    "channel_hint": "Embutido no pacote e não pode ser alterado depois.",
                    "status_label": "Status",
                    "status_hint": "Uma publicação nunca é excluída — ela é desativada. Depois disso, novos inícios são recusados e os resultados que ainda não saíram são cancelados.",
                    "settings_section": "Configurações da tentativa",
                    "attempts_label": "Tentativas por aluno",
                    "attempts_unlimited": "Sem limite",
                    "daily_budget_label": "Inícios por dia por aluno",
                    "daily_budget_hint": "Protege a cota: toda conversa iniciada é cobrada e nunca é devolvida.",
                    "result_mode_label": "O que retorna ao sistema de aprendizagem",
                    "pass_threshold_label": "Nota de aprovação, 0–100",
                    "result_wait_label": "Espera pela avaliação, em horas",
                    "result_wait_hint": "Depois disso, o início relata \"sem resultado\".",
                    "launch_limit_label": "Limite total de inícios",
                    "launch_limit_hint": "Deixe em branco para não haver limite.",
                    "assignment_check_label": "Verificar a atribuição no sistema de aprendizagem",
                    "binding_section": "Vínculo no sistema de aprendizagem",
                    "external_course_label": "ID do curso",
                    "external_item_label": "ID do item",
                    "expires_label": "Validade da publicação",
                    "expires_hint": "Deixe em branco se a publicação não tiver validade."
                },
                "key_dialog": {
                    "title": "A publicação foi criada",
                    "warning": "A chave é exibida uma única vez e apenas aqui. Ela não pode ser lida de volta de lugar nenhum — copie-a agora e coloque-a nas configurações do pacote. Perdê-la significa criar uma nova publicação.",
                    "key_label": "Chave da publicação",
                    "copied": "Copiado",
                    "package_hint": "A chave já está dentro do pacote, então não há nada para colar em lugar nenhum. Baixe o pacote e envie-o para o sistema de aprendizagem. Você pode baixá-lo novamente a qualquer momento na página de Publicações."
                },
                "messages": {
                    "saved": "Publicação salva",
                    "enabled": "Publicação ativada",
                    "disabled": "Publicação desativada",
                    "download_failed": "Não foi possível baixar o pacote. Atualize a página e tente novamente."
                }
            },
            "journal": {
                "title": "Registro de inícios",
                "unknown_scenario": "Cenário indisponível",
                "back": "Para publicações",
                "revoke": "Revogar a tentativa",
                "revoke_confirm": "Revogar esta tentativa? O aluno perde o acesso à conversa, e as entregas que ainda não saíram são canceladas.",
                "retry_delivery": "Tentar novamente",
                "empty_launches": "Ainda não há inícios.",
                "empty_events": "Ainda não há eventos.",
                "no_deliveries": "Esta tentativa não tem entregas.",
                "not_held_quota_charged": "Não aconteceu, cota cobrada",
                "relaunches": "retornos: {value}",
                "last_launch": "último início: {value}",
                "result_deadline": "Aguardando a avaliação até {value}",
                "learner_contacts": "Endereço enviado pelo sistema de aprendizagem: {email}. Iniciado a partir de: {ip}",
                "score_passed": "{value} — aprovado",
                "score_failed": "{value} — reprovado",
                "tabs": {
                    "launches": "Tentativas",
                    "events": "Eventos"
                },
                "headers": {
                    "learner": "Aluno",
                    "user": "Conta",
                    "attempt": "Tentativa",
                    "status": "Status",
                    "game": "Conversa",
                    "started_at": "Início",
                    "actions": " ",
                    "event_type": "Evento",
                    "refusal": "Motivo",
                    "request_proof": "Comprovante da solicitação",
                    "ip": "Endereço",
                    "user_agent": "Cliente",
                    "happened_at": "Quando"
                },
                "launch_status": {
                    "created": "Link emitido",
                    "started": "Em andamento",
                    "not_held": "Não aconteceu",
                    "awaiting_result": "Aguardando a avaliação",
                    "result_ready": "Resultado entregue",
                    "evaluation_failed": "Sem avaliação",
                    "result_timed_out": "O tempo de espera acabou",
                    "assignment_changed": "Atribuição alterada",
                    "revoked": "Revogada"
                },
                "delivery": {
                    "version": "Versão",
                    "status": "Status",
                    "outcome": "Desfecho",
                    "result": "Resultado",
                    "score": "Nota",
                    "attempts": "Tentativas",
                    "last_attempt": "Última tentativa",
                    "external_state": "Estado no sistema de aprendizagem"
                },
                "delivery_status": {
                    "pending": "Na fila",
                    "in_progress": "Enviando",
                    "done": "Concluída",
                    "needs_attention": "Precisa de atenção"
                },
                "delivery_outcome": {
                    "accepted": "Aceita",
                    "confirmed": "Confirmada",
                    "rejected_by_external": "Rejeitada",
                    "retry": "Nova tentativa agendada",
                    "cancelled": "Cancelada",
                    "assignment_changed": "Atribuição alterada"
                },
                "result": {
                    "passed": "Aprovado",
                    "failed": "Reprovado",
                    "not_held": "Não aconteceu",
                    "no_result": "Sem resultado"
                },
                "refusal": {
                    "publication_disabled": "Publicação desativada",
                    "publication_draft": "Publicação ainda é rascunho",
                    "publication_expired": "Publicação expirada",
                    "feature_disabled": "Lançamento externo desativado",
                    "connection_disabled": "Conexão desativada",
                    "launch_limit_reached": "Limite de inícios atingido",
                    "daily_budget_exhausted": "Cota diária esgotada",
                    "attempts_exhausted": "Tentativas esgotadas",
                    "quota_exhausted": "Cota da organização esgotada",
                    "user_limit_reached": "Sem vagas disponíveis",
                    "scenario_unavailable": "Cenário indisponível",
                    "assignment_check_unavailable": "Verificação de atribuição indisponível",
                    "code_invalid": "Link já usado ou expirado",
                    "channel_verification_failed": "Sistema de aprendizagem não confirmou a solicitação",
                    "external_system_unavailable": "Sistema de aprendizagem não respondeu à verificação de atribuição",
                    "user_not_found": "Sem conta para este aluno",
                    "user_unavailable": "Conta do aluno desativada",
                    "user_deleted": "Conta do aluno excluída",
                    "email_taken_linking_disabled": "E-mail pertence a outra conta",
                    "service_role_not_allowed": "Conta de serviço não pode praticar",
                    "unverified_request": "Solicitação não confirmada"
                },
                "event_type": {
                    "launch_refused": "Início recusado",
                    "exchange_refused": "Link recusado",
                    "exchange_succeeded": "Link utilizado"
                },
                "request_proof": {
                    "unverified": "Não confirmado",
                    "assignment_verified": "Atribuição confirmada"
                },
                "messages": {
                    "retry_queued": "Nova tentativa na fila",
                    "revoked": "Tentativa revogada"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Treinamento",
            "interview": "Entrevista"
        },
        "load": {
            "loading": "Carregando a sessão…",
            "failed": "Não foi possível carregar a sessão. Verifique sua conexão e tente novamente.",
            "scenarioFailed": "O cenário não foi carregado",
            "scenarioRetry": "Tentar novamente"
        },
        "leave": {
            "confirm": "A conversa ainda está em andamento. Sair não vai encerrá-la, e o tempo continua passando. Sair da página?",
            "confirmEnd": "A conversa ainda está em andamento. Se você sair, ela será encerrada e avaliada pelo que você conseguiu abordar. Sair?"
        },
        "elsewhere": {
            "interviewTitle": "A entrevista está aberta em outra aba",
            "interviewText": "A entrevista está em andamento em outra aba ou em outro dispositivo. Continue por lá — você pode fechar esta aba.",
            "conversationTitle": "A conversa está aberta em outra aba",
            "conversationText": "A conversa está em andamento em outra aba ou em outro dispositivo. Continue por lá — você pode fechar esta aba."
        },
        "prep": {
            "header": {
                "backToSessions": "Para sessões",
                "themeToggleAriaLabel": "Alternar tema"
            },
            "scenario": {
                "sectionLabel": "Cenário",
                "competenceLabel": "Competência avaliada",
                "gameNumber": "Sessão #{number}",
                "duration": "{minutes} min",
                "readFull": "Ler completo",
                "generalLabel": "Informações gerais",
                "playerLabel": "Informações para você"
            },
            "selfCamera": {
                "previewLabel": "Pré-visualização da sua câmera",
                "off": "Câmera desligada"
            },
            "notes": {
                "empty": "Vazio"
            },
            "start": {
                "button": "Iniciar sessão",
                "interviewButton": "Iniciar entrevista",
                "resumeButton": "Voltar à conversa",
                "resumeHint": "A conversa já está em andamento — o tempo continua passando."
            }
        },
        "equipment": {
            "status": {
                "checking": "Verificando o equipamento",
                "waiting": "Aguardando permissão",
                "denied": "Acesso negado",
                "busy": "Dispositivo em uso",
                "noCamera": "Sem câmera",
                "missing": "Sem microfone",
                "dismissed": "Acesso não concedido",
                "ready": "Equipamento pronto"
            },
            "checking": {
                "title": "Verificando seu microfone e câmera…"
            },
            "waiting": {
                "title": "Permita o acesso ao microfone",
                "cameraTitle": "Permita o acesso à câmera",
                "description": "A solicitação de permissão do navegador já está aberta. Sem microfone, a conversa não pode começar."
            },
            "denied": {
                "title": "O navegador está bloqueando o microfone",
                "cameraTitle": "O navegador está bloqueando a câmera",
                "description": "Seu navegador memorizou o bloqueio. Permita o acesso ao microfone nas configurações do site e atualize a página.",
                "cameraDescription": "Seu navegador memorizou o bloqueio. Permita o acesso à câmera nas configurações do site e atualize a página.",
                "showInstructions": "Mostrar como",
                "hideInstructions": "Ocultar",
                "chromeEdge": {
                    "browser": "Chrome e Edge",
                    "text": "Clique no ícone de cadeado à esquerda do endereço, abra \"Configurações do site\", permita \"Microfone\" e atualize a página."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Abra o menu do Safari → \"Ajustes para Este Site\", permita \"Microfone\" e atualize a página."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Clique no ícone de microfone na barra de endereço, remova o bloqueio para este site e atualize a página."
                },
                "system": {
                    "title": "Seu sistema está bloqueando o navegador de acessar o microfone",
                    "cameraTitle": "Seu sistema está bloqueando o navegador de acessar a câmera",
                    "macos": "macOS: Ajustes do Sistema → Privacidade e Segurança → Microfone (ou Câmera) → ative seu navegador e reinicie-o.",
                    "windows": "Windows: Configurações → Privacidade e segurança → Microfone (ou Câmera) → permita o acesso para os aplicativos e para o seu navegador e clique em \"Tentar novamente\"."
                }
            },
            "busy": {
                "title": "O microfone está sendo usado por outro aplicativo",
                "cameraTitle": "A câmera está sendo usada por outro aplicativo",
                "description": "Geralmente é uma chamada que ficou aberta em segundo plano. Feche-a e clique em \"Tentar novamente\".",
                "retry": "Tentar novamente"
            },
            "noCamera": {
                "title": "Sem câmera",
                "description": "Você será ouvido, mas não visto.",
                "requiredByScenario": "Esta conversa exige uma câmera. Conecte uma para continuar."
            },
            "missing": {
                "title": "Nenhum microfone encontrado",
                "description": "Conecte um microfone e clique em \"Tentar novamente\". A conversa não pode começar sem ele."
            },
            "dismissed": {
                "title": "O acesso ao microfone não foi concedido",
                "cameraTitle": "O acesso à câmera não foi concedido",
                "description": "A janela do navegador foi fechada sem resposta. Clique em \"Tentar novamente\" e permita o acesso."
            },
            "ready": {
                "title": "Equipamento pronto"
            },
            "micLabel": "Microfone",
            "cameraLabel": "Câmera",
            "chooseMic": "Escolher microfone",
            "chooseCamera": "Escolher câmera",
            "micLevelHint": "Diga algo",
            "speakerValue": "Alto-falante: {name}",
            "configure": "Configurar",
            "dialog": {
                "title": "Equipamento",
                "lockedDuringConversation": "Os dispositivos não podem ser trocados durante a conversa.",
                "micSelectLabel": "Microfone",
                "cameraSelectLabel": "Câmera",
                "speakerSelectLabel": "Alto-falante",
                "noCameraOption": "Sem câmera",
                "record": "Gravar 3 segundos",
                "recording": "Gravando…",
                "recordFailed": "Não foi possível gravar. Tente novamente.",
                "listen": "Reproduzir",
                "playing": "Reproduzindo…",
                "done": "Concluído",
                "closeAriaLabel": "Fechar diálogo"
            },
            "unnamed": {
                "microphone": "Microfone {number}",
                "camera": "Câmera {number}",
                "speaker": "Alto-falante {number}"
            },
            "cameraWarmup": {
                "preview": "A câmera está ligando",
                "title": "Microfone pronto",
                "description": "A câmera vai acompanhar — geralmente leva um ou dois segundos.",
                "slowHint": "A câmera não liga? Escolha outra em \"Configurar\"."
            }
        },
        "recording": {
            "videoAndAudio": "A conversa e o vídeo estão sendo gravados.",
            "audioOnly": "A conversa está sendo gravada.",
            "accessSelfAndEvaluators": "A gravação fica disponível para você e para quem avaliar seu trabalho.",
            "accessEvaluators": "A gravação fica disponível para quem avaliar seu trabalho."
        },
        "scenario": {
            "video": "Vídeo do autor do cenário"
        },
        "notes": {
            "title": "Notas da sessão",
            "placeholder": "O que você quer praticar, frases que preparou",
            "saving": "Salvando…",
            "saved": "Salvo",
            "saveError": "Não foi possível salvar",
            "visibility": "As notas ficam visíveis para você e para quem avaliar a sessão.",
            "unsupported": "Estas notas contêm elementos que não podem ser editados aqui. Elas foram mantidas sem alterações."
        },
        "stage": {
            "agentState": {
                "speaking": "Falando",
                "listening": "Ouvindo",
                "thinking": "Pensando"
            },
            "micOffWarning": "O microfone está desligado — o interlocutor não consegue ouvir você",
            "micOnAriaLabel": "Desligar microfone",
            "micOffAriaLabel": "Ligar microfone",
            "micOff": "Microfone desligado",
            "micOnAnnouncement": "Microfone ligado",
            "captionsLabel": "Legendas",
            "captionsOnAriaLabel": "Ocultar legendas",
            "captionsOffAriaLabel": "Mostrar legendas",
            "talkBalance": {
                "title": "Equilíbrio da fala",
                "you": "Você",
                "interlocutor": "Interlocutor"
            },
            "connectionQuality": {
                "excellent": "Conexão excelente",
                "good": "Conexão boa",
                "poor": "Conexão fraca",
                "unknown": "Qualidade de conexão desconhecida"
            },
            "selfCameraLabel": "Você",
            "timeWarning": {
                "lastMinute": "Falta um minuto — comece a encerrar",
                "finalSeconds": "15 segundos — termine sua ideia"
            },
            "timeUp": {
                "title": "O tempo acabou",
                "text": "A conversa será encerrada automaticamente; não é possível estendê-la.",
                "closing": "Encerrando a conversa…"
            },
            "voiceOnly": "Modo de voz — este cenário não tem vídeo",
            "interlocutorConnecting": {
                "title": "O interlocutor está se conectando",
                "hint": "Geralmente 2–4 segundos"
            },
            "layout": {
                "label": "Lado a lado",
                "sideTitle": "Colocar lado a lado",
                "focusTitle": "Ampliar o interlocutor"
            }
        },
        "panels": {
            "scenario": "Cenário",
            "transcript": "Transcrição",
            "transcriptEmpty": "As falas concluídas vão aparecer aqui.",
            "notes": "Notas",
            "characterMemoryTab": "O que o personagem lembra",
            "openAriaLabel": "Abrir o painel \"{panel}\"",
            "closeAriaLabel": "Fechar o painel \"{panel}\""
        },
        "sound": {
            "label": "Som",
            "volumeLabel": "Volume",
            "speakerLabel": "Alto-falante"
        },
        "end": {
            "button": "Encerrar",
            "confirmTitle": "Encerrar a conversa?",
            "elapsed": "Já se passaram {elapsed} de {total}.",
            "partialEvaluationNotice": "A conversa será avaliada pelo que você conseguiu abordar.",
            "continue": "Continuar",
            "notSent": "A conversa será encerrada pelo tempo: o servidor não respondeu ao pedido de encerramento."
        },
        "wait": {
            "title": "Preparando a conversa",
            "hint": "Geralmente leva 1–3 minutos. Não feche a página — vamos começar automaticamente.",
            "nextTry": "Próxima tentativa em {time}",
            "trying": "Tentando começar…",
            "retrying": "Ainda não deu. Tentando de novo em {time}",
            "cancel": "Cancelar",
            "failed": {
                "title": "Não foi possível iniciar a conversa",
                "text": "No momento não há vagas livres. As configurações de microfone e câmera foram salvas — tente novamente em alguns minutos.",
                "retry": "Tentar novamente"
            }
        },
        "connection": {
            "reconnecting": "Conexão perdida, reconectando…",
            "restored": "Conexão restaurada",
            "failed": "Não foi possível restaurar a conexão",
            "retry": "Tentar novamente"
        },
        "hotkeys": {
            "title": "Atalhos de teclado",
            "showHintAriaLabel": "Mostrar atalhos de teclado",
            "micToggle": "Ligar/desligar microfone",
            "scenarioPanel": "Cenário: abrir e fechar o painel",
            "transcriptPanel": "Transcrição",
            "notesPanel": "Notas",
            "captionsToggle": "Ligar/desligar legendas",
            "closeTopLayer": "Fechar o painel, popover ou diálogo",
            "endConfirm": "Encerrar — abre a confirmação",
            "showHint": "Mostrar esta dica"
        },
        "intro": {
            "candidate": {
                "greeting": "Olá, {name}!",
                "leadWithVacancy": "A {organization} convida você para uma entrevista com um interlocutor virtual para a vaga «{vacancy}».",
                "duration": "A entrevista dura cerca de {minutes} min.",
                "requirementsTitle": "O que você vai precisar",
                "requirementMic": "Um microfone funcionando, de preferência um headset",
                "requirementCameraRequired": "Câmera ligada: ela é obrigatória para esta entrevista",
                "requirementCameraOptional": "A câmera é opcional, mas com ela a conversa fica mais natural",
                "requirementBrowser": "Um computador com Chrome, Edge ou Safari atualizados",
                "requirementNetwork": "Uma conexão estável e um lugar tranquilo, sem interrupções",
                "consentTextLabel": "Texto do consentimento",
                "consentAccept": "Li o texto e autorizo o tratamento dos meus dados pessoais",
                "next": "Avançar"
            },
            "launch": {
                "title": "Conversa de prática",
                "lead": "Você vai conversar com um interlocutor virtual. A conversa é gravada e avaliada, e o resultado volta para o seu sistema de aprendizagem.",
                "requirementsTitle": "O que você vai precisar",
                "requirementMic": "Um microfone funcionando, de preferência um headset",
                "requirementCamera": "A câmera é opcional, mas a conversa fica mais natural com ela",
                "requirementBrowser": "Um computador com Chrome, Edge ou Safari atualizados",
                "requirementNetwork": "Uma conexão estável e um lugar tranquilo onde ninguém vai te interromper",
                "start": "Começar"
            }
        },
        "finished": {
            "candidate": {
                "title": "Obrigado!",
                "text": "A entrevista terminou. O resultado será enviado ao recrutador, que vai entrar em contato com você. Você já pode fechar esta página."
            },
            "launch": {
                "title": "Obrigado!",
                "text": "A conversa terminou. O resultado vai aparecer no seu sistema de aprendizagem assim que a avaliação estiver pronta. Você já pode fechar esta página."
            }
        },
        "closeDialogAriaLabel": "Fechar diálogo"
    },
    "loopAvatars": {
        "title": "Avatares em loop",
        "upload": "Enviar avatar",
        "newVersion": "Nova versão",
        "newVersionHint": "“{name}”, versão atual {version}. O novo pacote substitui os vídeos em todos os perfis com este avatar.",
        "edit": "Editar avatar",
        "delete": "Excluir avatar",
        "empty": "Nenhum avatar ainda",
        "headers": {
            "poster": "Pôster",
            "name": "Nome",
            "gender": "Gênero",
            "emotion": "Emoção",
            "visibility": "Visibilidade",
            "version": "Versão",
            "profiles": "Perfis"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "emotion": {
            "calm": "Calmo",
            "friendly": "Amigável",
            "strict": "Rigoroso"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "fields": {
            "package": "Pacote do avatar (.zip)"
        },
        "packageHint": "ZIP de até 100 MB com manifest.json, listen.mp4, talk.mp4, transitions.json e poster.jpg",
        "validation": {
            "packageTooLarge": "O pacote não pode ter mais de 100 MB"
        },
        "errors": {
            "requestFailed": "Não foi possível concluir a solicitação. Tente novamente."
        },
        "confirmDetach": "Perfis a desvincular: {count}. Eles passarão a usar a foto. Salvar?",
        "confirmDelete": "Excluir o avatar “{name}”?",
        "confirmDeleteWithProfiles": "O avatar “{name}” é usado em perfis: {count}. Eles passarão a usar a foto. Excluir?"
    },
    "ttsVoices": {
        "title": "Vozes TTS",
        "create": "Adicionar voz",
        "edit": "Editar voz",
        "delete": "Excluir voz",
        "replaceSample": "Substituir amostra",
        "replaceSampleHint": "“{name}”, versão atual da amostra {version}. A nova amostra será usada em todos os perfis com esta voz.",
        "empty": "Nenhuma voz ainda",
        "play": "Ouvir amostra",
        "stop": "Parar",
        "headers": {
            "name": "Nome",
            "provider": "Provedor",
            "externalId": "ID da voz",
            "gender": "Gênero",
            "languages": "Idiomas",
            "visibility": "Visibilidade",
            "sample": "Amostra",
            "profiles": "Perfis"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "fields": {
            "sample": "Amostra de voz",
            "speed": "Velocidade da fala"
        },
        "sampleHint": "MP3, MP4 ou M4A de até 5 MB",
        "sampleOptionalHint": "Opcional — a amostra será gerada com a voz pelo ID. MP3, MP4 ou M4A de até 5 MB",
        "synthesizeSample": "Gerar novamente",
        "speedChangedHint": "Para ouvir a nova velocidade, gere a amostra de voz novamente.",
        "speedSamplePromptTitle": "Velocidade alterada",
        "speedSamplePrompt": "A amostra ainda toca na velocidade anterior. Gerar novamente? A amostra atual será substituída.",
        "saveAndSynthesize": "Salvar e gerar",
        "saveOnly": "Somente salvar",
        "validation": {
            "sampleTooLarge": "A amostra não pode ter mais de 5 MB"
        },
        "errors": {
            "requestFailed": "Não foi possível concluir a solicitação. Tente novamente.",
            "sampleUnavailable": "Não foi possível reproduzir a amostra"
        },
        "confirmDetach": "Perfis a desvincular: {count}. Eles passarão a usar a voz do conector. Salvar?",
        "confirmDelete": "Excluir a voz “{name}”?",
        "confirmDeleteWithProfiles": "A voz “{name}” é usada em perfis: {count}. Eles passarão a usar a voz do conector. Excluir?",
        "picker": {
            "none": "Voz padrão",
            "empty": "Não há vozes deste gênero no catálogo",
            "loadError": "Não foi possível carregar as vozes",
            "playSample": "Ouvir amostra: {name}",
            "stopSample": "Parar amostra: {name}",
            "sampleUnavailable": "Amostra indisponível"
        }
    },
    "realtimeAvatars": {
        "title": "Avatares Live",
        "create": "Adicionar avatar",
        "edit": "Editar avatar",
        "delete": "Excluir avatar",
        "preview": "Ver prévia",
        "empty": "Ainda não há avatares",
        "headers": {
            "poster": "Pôster",
            "name": "Nome",
            "provider": "Provedor",
            "externalId": "ID do avatar",
            "gender": "Gênero",
            "visibility": "Visibilidade",
            "profiles": "Perfis",
            "models": "Modelos da Anam"
        },
        "gender": {
            "male": "Masculino",
            "female": "Feminino"
        },
        "visibility": {
            "all": "Todas as organizações"
        },
        "nameHint": "Opcional — será usado o nome da Anam",
        "externalIdHint": "Se você alterar o ID, o pôster e a prévia serão carregados novamente da Anam",
        "errors": {
            "requestFailed": "Não foi possível concluir a solicitação. Tente novamente.",
            "previewUnavailable": "Não foi possível reproduzir a prévia"
        },
        "confirmDetach": "Perfis que serão desvinculados: {count}. Eles passarão para a foto. Salvar?",
        "confirmDelete": "Excluir o avatar “{name}”?",
        "confirmDeleteWithProfiles": "O avatar “{name}” é usado em perfis: {count}. Eles passarão para a foto. Excluir?",
        "picker": {
            "label": "Avatares Live",
            "empty": "Nenhum avatar Live disponível para este perfil",
            "emptyFiltered": "Nenhum avatar Live deste gênero",
            "loadError": "Não foi possível carregar os avatares Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Aparência",
        "photo": "Foto própria",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascote",
        "filterGender": "Gênero",
        "filterEmotion": "Emoção",
        "avatarsLabel": "Avatares",
        "avatarRequired": "Escolha um avatar",
        "liveRequired": "Escolha um avatar Live",
        "livePlaceholder": "Seu avatar Live aparecerá aqui",
        "empty": "Nenhum avatar disponível para este perfil",
        "emptyFiltered": "Nenhum avatar corresponde aos filtros",
        "loadError": "Não foi possível carregar os avatares",
        "playPreview": "Reproduzir prévia: {name}",
        "pausePreview": "Pausar prévia: {name}"
    },
  "emailStopList": {
    "title": "Lista de bloqueio de email",
    "description": "Os emails para estes endereços e domínios não são enviados. A entrada de um domínio cobre todos os endereços desse domínio, mas não os seus subdomínios.",
    "searchPlaceholder": "Buscar por endereço ou domínio",
    "allReasons": "Todos os motivos",
    "add": "Adicionar",
    "addTitle": "Bloquear um endereço ou domínio",
    "empty": "A lista de bloqueio está vazia",
    "editNote": "Editar nota",
    "headers": {
      "type": "Tipo",
      "value": "Endereço ou domínio",
      "reason": "Motivo",
      "providerReply": "Resposta do serviço de email",
      "note": "Nota",
      "author": "Adicionado por",
      "createdAt": "Data de adição",
      "blockedCount": "Emails interrompidos",
      "lastBlockedAt": "Última interrupção"
    },
    "type": {
      "address": "Endereço",
      "domain": "Domínio"
    },
    "reason": {
      "manual": "Adicionado manualmente",
      "providerRejected": "Rejeitado pelo serviço de email"
    },
    "author": {
      "system": "Sistema"
    },
    "fields": {
      "value": "Endereço ou domínio",
      "valueHint": "Informe um endereço completo ou apenas um domínio. Um domínio bloqueia todos os seus endereços, mas não os subdomínios.",
      "note": "Nota"
    },
    "errors": {
      "requestFailed": "Algo deu errado. Tente novamente."
    },
    "unblock": {
      "action": "Desbloquear",
      "confirm": "Desbloquear {value}?",
      "resultTitle": "Resultado do desbloqueio",
      "result": {
        "removedEverywhere": "Desbloqueado. O serviço de email não tem este endereço na sua lista de bloqueio, então os emails voltarão a ser enviados.",
        "removedLocally": "Domínio desbloqueado. Os endereços deste domínio que têm uma entrada própria continuam bloqueados.",
        "providerNotConfigured": "Apenas a entrada da plataforma foi removida: a conexão com o serviço de email não está configurada, então a lista de bloqueio dele não foi verificada.",
        "providerUnavailable": "O serviço de email está indisponível, tente novamente mais tarde. O endereço continua bloqueado.",
        "stillListedAtProvider": "O endereço está na lista de bloqueio do serviço de email. Remova-o no painel do serviço e clique em «Desbloquear novamente». Se o painel não mostrar o endereço, ele está na lista de bloqueio global do serviço e não pode ser removido de lá."
      },
      "openPanel": "Abrir o painel do serviço de email",
      "panelPath": "Onde remover: painel do serviço de email → Products → Email Service → seu recurso → aba Stop Lists.",
      "retry": "Desbloquear novamente"
    },
    "suggestions": {
      "text": "O domínio {domain} tem {count} endereços bloqueados. Bloquear o domínio inteiro?",
      "block": "Bloquear domínio",
      "confirm": "Bloquear o domínio {domain}? Os emails para todos os seus endereços deixarão de ser enviados. Os subdomínios não são afetados, e as entradas de endereços individuais permanecem."
    },
    "check": {
      "title": "Verificar um endereço",
      "hint": "Mostra se os emails para o endereço são bloqueados pela plataforma ou pelo serviço de email",
      "placeholder": "Endereço de email",
      "submit": "Verificar",
      "resultFor": "Resultado para {email}",
      "platform": "Lista de bloqueio da plataforma",
      "platformListed": "Sim — entrada «{value}»",
      "provider": "Lista de bloqueio do serviço de email",
      "listed": "Sim",
      "notListed": "Não",
      "providerReasons": "Motivos informados pelo serviço de email:",
      "providerNotConfigured": "A conexão com o serviço de email não está configurada",
      "providerUnavailable": "O serviço de email está indisponível, tente novamente mais tarde"
    }
  }
}
